var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 505.022,
    height: 842.914,
    viewBox: "0 0 505.022 842.914",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1e1e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 49.364,
    y1: 10.667,
    x2: 49.394,
    y2: 10.161,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "#492219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#652f23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 49.172,
    y1: 10.685,
    x2: 49.055,
    y2: 10.113,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 53.462,
    y1: 11.207,
    x2: 53.988,
    y2: 10.022,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#673024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#6b3227"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#783b30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 238.326,
    y1: 18.129,
    x2: 241.293,
    y2: 16.925,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 237.769,
    y1: 16.091,
    x2: 240.721,
    y2: 15.031,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfd3f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#c1d4f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#cadaf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0def6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.536,
    y1: 4.365,
    x2: 0.447,
    y2: -4.19,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dce7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821,
    stopColor: "#d6e2f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4e1f6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.498,
    cy: 0.485,
    r: 2.974,
    gradientTransform: "translate(0.922 -30.808) scale(0.143 0.159)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e3e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.387,
    stopColor: "#e9e8e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#f7f6f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefdfc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0c499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#f1c69b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#f4cea4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -3.094,
    y1: -0.438,
    x2: 1.732,
    y2: 0.822,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd9b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 0.496,
    y1: 1.014,
    x2: 0.506,
    y2: 0.234,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#0f0f10"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b0b0c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 0.494,
    y1: 1.012,
    x2: 0.503,
    y2: 0.235,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 0.285,
    y1: 0.244,
    x2: 0.698,
    y2: 1.486,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 531.687,
    y1: -0.42,
    x2: 528.372,
    y2: 0.685,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: -0.111,
    y1: 0.778,
    x2: 0.901,
    y2: -0.021,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1.07,
    y1: 1.048,
    x2: 0.13,
    y2: -0.255,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.456,
    y1: 0.048,
    x2: 0.576,
    y2: 0.971,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dba379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#e3b086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 0.498,
    y1: -0.062,
    x2: 0.518,
    y2: 0.991,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: -0.017,
    y1: -0.232,
    x2: 0.969,
    y2: 0.994,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d5e2f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.534,
    stopColor: "#dce7fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#d6e2f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d4e1f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 0.59,
    y1: 2.543,
    x2: 0.476,
    y2: -0.401,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 0.993,
    y1: 1.133,
    x2: 0.209,
    y2: -0.112,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: -0.238,
    y1: 0.981,
    x2: 1.43,
    y2: 0.014,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 0.588,
    y1: -0.518,
    x2: 0.47,
    y2: 1.005,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b2b2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 0.523,
    y1: -0.187,
    x2: 0.472,
    y2: 1.581,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 0.502,
    y1: -0.935,
    x2: 0.5,
    y2: 1.003,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#1c1c1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#262627"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 0.536,
    y1: -0.256,
    x2: 0.469,
    y2: 1.998,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 0.531,
    y1: -0.94,
    x2: 0.489,
    y2: 1.004,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 0.525,
    y1: -0.941,
    x2: 0.491,
    y2: 1.004,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: -1.738,
    y1: 0.382,
    x2: -1.125,
    y2: 1.451,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 1.793,
    y1: 1.049,
    x2: 2.007,
    y2: 2.693,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b3329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.421,
    stopColor: "#5c2b22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#421f16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 0.875,
    y1: -7.204,
    x2: 1.692,
    y2: -5.01,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: -11.738,
    y1: 22.177,
    x2: -11.721,
    y2: 22.177,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.517,
    stopColor: "#f5d1a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.855,
    stopColor: "#f2c99f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: -12.557,
    y1: 23.604,
    x2: -12.54,
    y2: 23.604,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.521,
    cy: 0.483,
    r: 0.445,
    gradientTransform: "matrix(-1.163, 0.229, -0.295, -1.051, -29.463, 48.451)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9b38e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#f7c59e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: -61.738,
    y1: 134.27,
    x2: -61.659,
    y2: 134.27,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1.658,
    y1: 1.235,
    x2: 0.901,
    y2: 3.41,
    xlinkHref: "#linear-gradient-34"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 1.927,
    y1: 1.493,
    x2: 3.193,
    y2: 3.098,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b3329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#52271d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#421f16"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.464,
    cy: 0.501,
    r: 0.457,
    gradientTransform: "matrix(1.141, 0.216, 0.255, -0.986, -3.685, 49.404)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: -51.849,
    y1: 140.946,
    x2: -51.771,
    y2: 140.946,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 2.326,
    y1: 1.716,
    x2: -0.457,
    y2: 3.736,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b3329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.038,
    stopColor: "#683127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#52271d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#462117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#421f16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 1.221,
    y1: 2.387,
    x2: 2.317,
    y2: 2.387,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#673024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#7a3c31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 4.293,
    y1: 1.312,
    x2: 4.21,
    y2: 2.073,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#673024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.413,
    stopColor: "#6a3126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#74382d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#824137"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: -138.093,
    y1: 6.187,
    x2: -137.941,
    y2: 8.055,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 0.459,
    y1: 0.096,
    x2: 0.612,
    y2: 1.965,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 20.958,
    y1: 3.674,
    x2: 21.466,
    y2: 5.959,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b3329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#5a2b21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#482219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#421f16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 2.671,
    y1: 3.233,
    x2: 2.448,
    y2: 2.172,
    xlinkHref: "#linear-gradient-43"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 5.432,
    y1: 1.454,
    x2: 6.187,
    y2: 0.101,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#421f16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.299,
    stopColor: "#482219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#5a2b21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6b3329"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 0.694,
    y1: 1.308,
    x2: 0.645,
    y2: 0.34,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: -62.622,
    y1: 153.064,
    x2: -62.475,
    y2: 153.064,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: -79.037,
    y1: 133.87,
    x2: -78.883,
    y2: 133.87,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: -18.402,
    y1: 114.583,
    x2: -18.361,
    y2: 114.583,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#efe4e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#faf8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8d2d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: -16.667,
    y1: 115.643,
    x2: -16.632,
    y2: 115.643,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.041,
    stopColor: "#ebdddc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211,
    stopColor: "#f6f0ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#fcfbfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#fbf7f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#f1e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8d2d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: -17.092,
    y1: 79.641,
    x2: -17.056,
    y2: 79.641,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f96e7e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.035,
    stopColor: "#f9707f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#fd7985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.528,
    stopColor: "#ff7d88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.764,
    stopColor: "#fd7985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#f86d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f86d7d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: -17.284,
    y1: 193.691,
    x2: -17.247,
    y2: 193.691,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d8d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#eadcdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    stopColor: "#f6efee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484,
    stopColor: "#fbf6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8d2d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: -22.857,
    y1: 321.596,
    x2: -22.808,
    y2: 321.596,
    xlinkHref: "#linear-gradient-55"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#673024"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336,
    stopColor: "#52261c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#462017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#421f16"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#421f16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#462017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#52261c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#673024"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 0.888,
    y1: 0.265,
    x2: 0.052,
    y2: 0.761,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0c499"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#e3b086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dba379"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: -0.022,
    y1: 0.5,
    x2: 0.978,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.773,
    stopColor: "#f5f3f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ece7e7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 0.302,
    y1: 0.5,
    x2: 0.821,
    y2: 0.5,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 1.284,
    y1: 1.341,
    x2: 0.018,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b89c8c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715241"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 2.276,
    y1: 3.296,
    x2: 0.925,
    y2: 1.276,
    xlinkHref: "#linear-gradient-63"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.36,
    cy: 0.558,
    r: 0.595,
    gradientTransform: "translate(0.017) scale(0.967 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a3a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c2727"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: -0.006,
    y1: 0.5,
    x2: 0.994,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#391b13"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343,
    stopColor: "#3d1c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706,
    stopColor: "#492219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5a2a1f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 0.399,
    y1: 0.127,
    x2: 1.096,
    y2: 3.452,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 0.503,
    y1: 1.439,
    x2: 0.5,
    y2: -0.041,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: -9.257,
    y1: -20.072,
    x2: -9.675,
    y2: -22.125,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 0.949,
    y1: 0.216,
    x2: 0.027,
    y2: 1.232,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 0.058,
    y1: 0.22,
    x2: 0.989,
    y2: 1.259,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 0.957,
    y1: 0.256,
    x2: -0.002,
    y2: 0.826,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: -0.022,
    y1: 0.5,
    x2: 0.978,
    y2: 0.5,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 1.122,
    y1: 1.02,
    x2: -0.114,
    y2: -0.131,
    xlinkHref: "#linear-gradient-63"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 2.197,
    y1: 1.127,
    x2: 0.549,
    y2: 0.581,
    xlinkHref: "#linear-gradient-63"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.36,
    cy: 0.558,
    r: 0.595,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: -0.006,
    y1: 0.5,
    x2: 0.994,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a2a1f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#492219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#3d1c14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#391b13"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 0.566,
    y1: 0.325,
    x2: -0.455,
    y2: 4.688,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 5.514,
    y1: 1.653,
    x2: 6.239,
    y2: 1.653,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.681,
    stopColor: "#fcd7b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 0.507,
    y1: 0.454,
    x2: 0.576,
    y2: 4.619,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: -42.962,
    y1: 187.851,
    x2: -42.915,
    y2: 187.851,
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: -0.227,
    y1: -3.023,
    x2: -0.222,
    y2: -3.812,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2f2e2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b0a0a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 0.378,
    y1: 0.006,
    x2: 0.565,
    y2: 0.879,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 0.523,
    y1: 1.107,
    x2: 0.407,
    y2: -1.217,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 0.738,
    y1: -0.051,
    x2: 0.424,
    y2: 0.918,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 0.521,
    y1: 1.1,
    x2: 0.402,
    y2: -1.343,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 0.47,
    y1: 1.043,
    x2: 0.538,
    y2: 0.025,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: -0.556,
    y1: 1.387,
    x2: 1.1,
    y2: -0.451,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: -4.61,
    y1: 1.026,
    x2: -4.54,
    y2: 0.012,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: -3.531,
    y1: 0.011,
    x2: -3.586,
    y2: 2.007,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#f8f8fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 1.064,
    y1: 1.376,
    x2: -0.097,
    y2: -0.178,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 0.514,
    y1: -0.076,
    x2: 0.466,
    y2: 1.852,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: -0.052,
    y1: 0.899,
    x2: 1.429,
    y2: -0.139,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 0.179,
    y1: -0.025,
    x2: 0.944,
    y2: 1.205,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 0.05,
    y1: -0.051,
    x2: 0.876,
    y2: 1.223,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 1.161,
    y1: 2.235,
    x2: -0.247,
    y2: 2.088,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: -61.57,
    y1: 28.002,
    x2: -59.449,
    y2: 28.322,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: -0.225,
    y1: 2.09,
    x2: 0.819,
    y2: 2.226,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: -0.567,
    y1: 0.433,
    x2: -0.801,
    y2: 2.149,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 0.771,
    y1: 2.038,
    x2: -0.438,
    y2: 1.211,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: -1.473,
    y1: 0.399,
    x2: -0.959,
    y2: 1.473,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: -0.422,
    y1: 1.665,
    x2: 0.659,
    y2: 1.479,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: -0.481,
    y1: 0.309,
    x2: 0.793,
    y2: 1.551,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: -1.413,
    y1: -0.154,
    x2: -2.325,
    y2: 1.028,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a7aaab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.098,
    stopColor: "#b7babb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#cbcdce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.346,
    stopColor: "#d2d4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#e1e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.756,
    stopColor: "#dcdfdf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#d0d3d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#bcbfbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a7aaab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: -1.187,
    y1: 0.433,
    x2: -0.391,
    y2: 0.433,
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: -13.298,
    y1: -0.064,
    x2: -13.114,
    y2: 0.913,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b9bbbb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#c3c5c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cdcece"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: -15.31,
    y1: 0.403,
    x2: -14.31,
    y2: 0.403,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2d4d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dddfe0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: -23.878,
    y1: -0.138,
    x2: -23.485,
    y2: 1.328,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: -28.002,
    y1: -0.101,
    x2: -27.955,
    y2: 1.129,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2e3e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#eceded"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1f1f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 0.557,
    y1: 1.73,
    x2: 0.437,
    y2: -0.553,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.935,
    stopColor: "#fdfdfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 0.56,
    y1: 1.734,
    x2: 0.436,
    y2: -0.541,
    xlinkHref: "#linear-gradient-109"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: -63.16,
    y1: 6.571,
    x2: -61.741,
    y2: 5.277,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#f5d0a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.974,
    stopColor: "#f1c69c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1c69c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: -72.085,
    y1: 19.816,
    x2: -70.102,
    y2: 20.046,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 0.797,
    y1: 1.922,
    x2: -0.195,
    y2: 1.162,
    xlinkHref: "#linear-gradient-78"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: -192.581,
    y1: 15.332,
    x2: -190.915,
    y2: 15.386,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: -143.564,
    y1: 37.723,
    x2: -141.558,
    y2: 37.943,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: -142.757,
    y1: 52.291,
    x2: -140.689,
    y2: 52.609,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: -90.32,
    y1: 17.8,
    x2: -88.347,
    y2: 17.961,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: -2.107,
    y1: 2.199,
    x2: -0.94,
    y2: 1.851,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 1.235,
    y1: 0.881,
    x2: -0.45,
    y2: 1.497,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: -278.646,
    y1: 30.028,
    x2: -278.362,
    y2: 30.476,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1c69c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: -412.753,
    y1: 31.866,
    x2: -414.158,
    y2: 30.955,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: -180.963,
    y1: 27.685,
    x2: -181.038,
    y2: 27.951,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: -393.228,
    y1: 40.179,
    x2: -394.402,
    y2: 39.166,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: -185.937,
    y1: 36.285,
    x2: -185.572,
    y2: 36.628,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: -236.463,
    y1: 27.031,
    x2: -237.698,
    y2: 26.305,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: -256.609,
    y1: 73.984,
    x2: -256.512,
    y2: 74.64,
    xlinkHref: "#linear-gradient-120"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: -0.297,
    y1: 0.397,
    x2: -0.87,
    y2: 1.633,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 0.314,
    y1: 2.482,
    x2: 0.344,
    y2: 1.209,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 0.612,
    y1: 0.663,
    x2: 1.132,
    y2: 1.733,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 0.587,
    y1: 0.424,
    x2: -0.437,
    y2: 1.325,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.498,
    cy: 0.485,
    r: 3.799,
    gradientTransform: "translate(1.568 -40.966) scale(0.112 0.124)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e4e3e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.396,
    stopColor: "#eae9e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.931,
    stopColor: "#fbfaf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefdfc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 0.36,
    y1: -0.063,
    x2: 0.515,
    y2: 1.097,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9d9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#cbdaf5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d0def6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 86.411,
    y1: 3.526,
    x2: 86.411,
    y2: 2.268,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 474.814,
    y1: 6.372,
    x2: 478.102,
    y2: 8.543,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 118.54,
    y1: 16.55,
    x2: 118.583,
    y2: 20.771,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a2828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.463,
    stopColor: "#201e1e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1c1a1a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 133.741,
    y1: 8.623,
    x2: 132.611,
    y2: 10.956,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1a1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#282829"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 40.965,
    y1: 1.938,
    x2: 40.965,
    y2: 0.68,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 226.883,
    y1: 1.072,
    x2: 230.171,
    y2: 3.243,
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 55.771,
    y1: 4.02,
    x2: 55.814,
    y2: 8.241,
    xlinkHref: "#linear-gradient-135"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 63.199,
    y1: 2.568,
    x2: 62.069,
    y2: 4.901,
    xlinkHref: "#linear-gradient-136"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 0,
    y1: 0.5,
    x2: 2.242,
    y2: 0.5,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 0.584,
    y1: 0.104,
    x2: 0.222,
    y2: 1.694,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 0.49,
    y1: 1.388,
    x2: 0.514,
    y2: 0.375,
    xlinkHref: "#linear-gradient-27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 0.515,
    y1: -0.94,
    x2: 0.498,
    y2: 1.004,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: -0.017,
    y1: 0.536,
    x2: 1.132,
    y2: 0.472,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: -0.159,
    y1: 0.482,
    x2: 0.886,
    y2: 0.506,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#686868"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.381,
    stopColor: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "#3a3a3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343435"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: -0.126,
    y1: 0.071,
    x2: 1.687,
    y2: 1.607,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: -0.019,
    y1: 0.09,
    x2: 1.828,
    y2: 1.547,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 0.44,
    y1: -0.137,
    x2: 0.528,
    y2: 1.208,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0056a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#2174bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3182ca"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 0.348,
    y1: 1.245,
    x2: 0.571,
    y2: 0.261,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 0.355,
    y1: 0.859,
    x2: 0.616,
    y2: 0.124,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 0.448,
    y1: -0.015,
    x2: 0.527,
    y2: 1.164,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: -15.412,
    y1: 10.378,
    x2: -14.43,
    y2: 10.378,
    xlinkHref: "#linear-gradient-150"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: -6.302,
    y1: 3.762,
    x2: -6.365,
    y2: 5.085,
    xlinkHref: "#linear-gradient-150"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: -13.123,
    y1: 11.391,
    x2: -12.112,
    y2: 11.391,
    xlinkHref: "#linear-gradient-150"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: -8.356,
    y1: 11.249,
    x2: -8.379,
    y2: 9.604,
    xlinkHref: "#linear-gradient-150"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 0.48,
    y1: 1.013,
    x2: 0.561,
    y2: -0.025,
    xlinkHref: "#linear-gradient-150"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 0.516,
    y1: 3.276,
    x2: 0.494,
    y2: 0.027,
    xlinkHref: "#linear-gradient-109"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: -0.223,
    y1: 0.046,
    x2: 1.561,
    y2: 0.725,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 1.01,
    y1: 1.164,
    x2: -0.081,
    y2: -0.029,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 0.034,
    y1: 1.085,
    x2: 1.061,
    y2: 0.054,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 1.1,
    y1: 0.006,
    x2: -0.022,
    y2: 0.709,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 0.737,
    y1: 2.212,
    x2: 0.526,
    y2: 0.335,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.525,
    stopColor: "#f1c89d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 0.445,
    y1: 0.208,
    x2: 0.626,
    y2: 1.112,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 0.537,
    y1: 0.268,
    x2: 0.423,
    y2: 0.966,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 1.283,
    y1: 0.507,
    x2: 0.067,
    y2: 0.496,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 1.406,
    y1: -0.407,
    x2: 0.208,
    y2: 0.991,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 0.782,
    y1: 0.31,
    x2: 0.347,
    y2: 0.815,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 0.479,
    y1: 1.378,
    x2: 0.534,
    y2: -0.743,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: -3.998,
    y1: 11.106,
    x2: -3.855,
    y2: 9.276,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: -3.508,
    y1: 14.231,
    x2: -3.397,
    y2: 12.144,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: -3.562,
    y1: 13.435,
    x2: -3.445,
    y2: 11.408,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 0.501,
    y1: 0.532,
    x2: 0.523,
    y2: 1.786,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 0.501,
    y1: 0.534,
    x2: 0.55,
    y2: 1.872,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: -0.031,
    y1: -0.562,
    x2: 0.7,
    y2: 0.893,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 0.318,
    y1: 0.294,
    x2: 3.863,
    y2: 4.294,
    xlinkHref: "#linear-gradient-131"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: -0.381,
    y1: -0.075,
    x2: 1.356,
    y2: 1.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 0.501,
    y1: 0.542,
    x2: 0.523,
    y2: 2.182,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 0.477,
    y1: 0.934,
    x2: 0.558,
    y2: -0.158,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 0.266,
    y1: 1.025,
    x2: 0.796,
    y2: -0.258,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 0.662,
    y1: -0.173,
    x2: 0.397,
    y2: 1.076,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 0.567,
    y1: -0.081,
    x2: 0.339,
    y2: 1.798,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 0.032,
    y1: 0.836,
    x2: 0.702,
    y2: 0.355,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 0.038,
    y1: 0.298,
    x2: 1,
    y2: 0.58,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 0.332,
    y1: 0.859,
    x2: 1.093,
    y2: -0.025,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 0.603,
    y1: 0.886,
    x2: 0.192,
    y2: -0.571,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 1.701,
    y1: -0.487,
    x2: 0.358,
    y2: 0.785,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: -0.008,
    y1: 0.444,
    x2: 1.181,
    y2: 0.574,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 0.466,
    y1: 1.042,
    x2: 0.542,
    y2: 0.025,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 4.417,
    y1: 1.051,
    x2: 4.491,
    y2: 0.037,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: -0.274,
    y1: 0.076,
    x2: 1.246,
    y2: 1.638,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: -0.917,
    y1: -1.303,
    x2: -1.829,
    y2: -0.121,
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: -0.918,
    y1: -1.118,
    x2: -0.122,
    y2: -1.118,
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 6.028,
    y1: 0.063,
    x2: 6.212,
    y2: 1.04,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 6.238,
    y1: 0.545,
    x2: 7.238,
    y2: 0.545,
    xlinkHref: "#linear-gradient-106"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 9.991,
    y1: 0.084,
    x2: 10.383,
    y2: 1.55,
    xlinkHref: "#linear-gradient-105"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 11.668,
    y1: 0.165,
    x2: 11.715,
    y2: 1.395,
    xlinkHref: "#linear-gradient-108"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 0.563,
    y1: 1.734,
    x2: 0.433,
    y2: -0.542,
    xlinkHref: "#linear-gradient-109"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 0.565,
    y1: 1.73,
    x2: 0.433,
    y2: -0.553,
    xlinkHref: "#linear-gradient-109"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: -0.672,
    y1: -0.777,
    x2: 2.104,
    y2: 2.572,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 0.791,
    y1: -0.233,
    x2: -0.607,
    y2: 3.214,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 58.313,
    y1: 1.376,
    x2: 58.794,
    y2: -0.585,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: -1.948,
    y1: 10.357,
    x2: -0.952,
    y2: 10.357,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 1.136,
    y1: 1.145,
    x2: 1.629,
    y2: -0.839,
    xlinkHref: "#linear-gradient-89"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 1.05,
    y1: -5.65,
    x2: 2.048,
    y2: -5.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 7.06,
    y1: 32.433,
    x2: 8.403,
    y2: 33.409,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 135.236,
    y1: 25.646,
    x2: 136.822,
    y2: 26.613,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 0.531,
    y1: 1.034,
    x2: 0.489,
    y2: 0.387,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: -0.144,
    y1: 0.483,
    x2: 1.088,
    y2: 0.534,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#636872"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    stopColor: "#5f646d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#545961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.809,
    stopColor: "#42464b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323639"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 190.287,
    y1: 0.849,
    x2: 190.244,
    y2: 0.198,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 0.417,
    y1: -1.115,
    x2: 0.556,
    y2: 1.523,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 0.815,
    y1: 1.182,
    x2: 0.252,
    y2: 0.229,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#f5cfa6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 0.488,
    y1: 0.022,
    x2: 0.507,
    y2: 0.734,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7c0c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#a3abb4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.355,
    stopColor: "#878e97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.578,
    stopColor: "#737882"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.795,
    stopColor: "#676c76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636872"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 0.864,
    y1: 0.094,
    x2: -0.793,
    y2: 2.199,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#fbd6af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 1.744,
    y1: 1.805,
    x2: 0.144,
    y2: 0.205,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.717,
    stopColor: "#fbd6af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd9b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient-211"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 0.686,
    y1: 2.698,
    x2: 0.63,
    y2: 0.147,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    stopColor: "#f6d1a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "#f2c99f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f1c59a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 0.717,
    y1: 2.75,
    x2: 0.653,
    y2: 0.148,
    xlinkHref: "#linear-gradient-219"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 0.679,
    y1: 10.673,
    x2: 0.638,
    y2: 1.312,
    xlinkHref: "#linear-gradient-219"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: -0.004,
    y1: 1.008,
    x2: 1.197,
    y2: 1.113,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d9d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#efe5e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#faf8f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.569,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8d3d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 0.592,
    y1: 5.352,
    x2: 0.559,
    y2: 0.678,
    xlinkHref: "#linear-gradient-219"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 0.493,
    y1: -0.898,
    x2: 0.508,
    y2: 1.092,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e8d9d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#efe5e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 0.547,
    y1: 12.866,
    x2: 0.529,
    y2: -1.265,
    xlinkHref: "#linear-gradient-219"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 0.425,
    y1: -0.418,
    x2: 0.52,
    y2: 1.209,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd9b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.196,
    stopColor: "#fcd7b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d4ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 0.031,
    y1: -7.52,
    x2: 0.026,
    y2: -9.154,
    xlinkHref: "#linear-gradient-36"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 0.453,
    y1: -2.165,
    x2: 0.506,
    y2: 1.006,
    xlinkHref: "#linear-gradient-219"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 0.458,
    y1: 1.068,
    x2: 0.593,
    y2: -0.197,
    xlinkHref: "#linear-gradient-216"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#323639"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#42464b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#545961"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.742,
    stopColor: "#5f646d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636872"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 0.497,
    y1: -0.137,
    x2: 0.504,
    y2: 1.227,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9aa4b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#adb6c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0c8d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 0.031,
    y1: 0.265,
    x2: 1.014,
    y2: 0.808,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 0.965,
    y1: 0.585,
    x2: -0.127,
    y2: 0.377,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 1.142,
    y1: 1.043,
    x2: -0.228,
    y2: 0.015,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ddddda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4a59d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 4.755,
    y1: -19.08,
    x2: 3.741,
    y2: -20.825,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5c6c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94958d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.927,
    cy: 0.831,
    r: 1.447,
    gradientTransform: "matrix(0.973, 0.058, -0.057, 1.018, 0.122, -0.148)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 71.297,
    y1: 1.205,
    x2: 72.283,
    y2: 1.733,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: 1.002,
    y1: 0.735,
    x2: 0.182,
    y2: 0.317,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 1.003,
    y1: 0.471,
    x2: -0.371,
    y2: 0.55,
    xlinkHref: "#linear-gradient-234"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 1.027,
    y1: 0.793,
    x2: 0.136,
    y2: 0.377,
    xlinkHref: "#linear-gradient-235"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 0.069,
    cy: 0.829,
    r: 1.447,
    gradientTransform: "matrix(-0.973, 0.047, 0.047, 1.018, 472.092, -10.996)",
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: -0.138,
    y1: 0.484,
    x2: 1.214,
    y2: 0.536,
    xlinkHref: "#linear-gradient-230"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: 2.185,
    y1: 0.019,
    x2: -0.089,
    y2: 0.59,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: 0.956,
    y1: 1.13,
    x2: -0.051,
    y2: 0.168,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0c499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: 0.003,
    y1: 1.114,
    x2: 1.077,
    y2: 0.164,
    xlinkHref: "#linear-gradient-38"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: 0.594,
    y1: 3.527,
    x2: 0.523,
    y2: 1.034,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#565658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2b2a2d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "login-doctor",
    transform: "translate(-290.181 -140.671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_529",
    "data-name": "Group 529"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1274",
    "data-name": "Path 1274",
    d: "M610.931,720.495l45.894-.685-.071-33.409-50.807,3.893Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_505",
    "data-name": "Group 505"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1275",
    "data-name": "Path 1275",
    d: "M649.652,245.045c6.535-10.091,40.739-7.591,16.369,34.421-17.477,30.131-54.623,19.645-44.961,2.17C630.661,264.271,643.12,255.135,649.652,245.045Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M664.958,280.256c-2.2,2.547-7.256,20.228-24.466,20.33-10.821.064-19-4.907-20.262-9.839,0,0,6.059,3.867,11.93,2.085s10.487-24.174,10.487-24.174,2.842,16.18,4.185,15.071,2.09-32.262,7-36.449,10.206-8.1,14.883-5.183S683.511,258.737,664.958,280.256Z",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1277",
    "data-name": "Path 1277",
    d: "M667.571,241.521s13.4,5.626,8.341,23.527c-2.205,7.8-8.688,12.668-10.386,15.569s-2.365,14.026-16.732,20.144c-7.52,3.205-14.892,1.792-22.989-3.764a27.233,27.233,0,0,0,26.39-2.035c8.393-5.319,9.525-11.767,11.766-15.457s10.071-7.9,11.318-21.574C676.165,248.2,667.571,241.521,667.571,241.521Z",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1278",
    "data-name": "Path 1278",
    d: "M656.555,261.934s19.966,17.473-3.446,34.233C653.109,296.167,669.625,283.1,656.555,261.934Z",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1279",
    "data-name": "Path 1279",
    d: "M653.655,260.234s6.437,10.516,6.27,17.955-2,15.188-11.439,20.907c0,0,8.32-6.2,8.827-19.215C657.595,272.589,653.655,260.234,653.655,260.234Z",
    fill: "url(#linear-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1280",
    "data-name": "Path 1280",
    d: "M579.914,310.578s3.092-15.363,22.735-18.5c23.259-3.72,57.1-4.23,61.329,12.16S579.914,310.578,579.914,310.578Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1281",
    "data-name": "Path 1281",
    d: "M590.842,298.771c-7.511,3.9-1.576-1.466-3.526-.881,0,0,14.066-9.518,36.3-9.341,22.028.177,36.889,6.8,37.538,10.4-.145-.8-.084.683-1.392.432-1.53-.295-4.6-2.309-7.067-3.252-7.441-2.844-19.021-4.255-27.846-3.877C609.689,292.9,604.41,291.722,590.842,298.771Z",
    fill: "#fcfefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1282",
    "data-name": "Path 1282",
    d: "M588.4,308.64c-.187-.935,5.06-7.455,6.662-7.936,30.55-9.165,53.231-2.913,57.159.641s8.566,20.37,8.566,20.37l-69.2,1.683Z",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1283",
    "data-name": "Path 1283",
    d: "M593.967,301.345s5.2-5.386,30.212-5.634c13.371-.134,26.682,1.759,29.763,5.634l.792,6.983s2.991-12.22-29.928-11.222c-26.172.793-29.144,5.984-32.669,10.225Z",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_506",
    "data-name": "Group 506"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_33",
    "data-name": "Ellipse 33",
    cx: 124.964,
    cy: 17.853,
    rx: 124.964,
    ry: 17.853,
    transform: "translate(545.276 942.898)",
    fill: "url(#radial-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1284",
    "data-name": "Path 1284",
    d: "M566.791,680.864s6.741,37.181,5.618,51.124-3.118,53.19.126,66.617,32.947,90.856,33.019,95.019c.119,6.914.7,18.913.7,18.913l-1.826,43.572,29.455-1.344s1-20.464.319-24.024c-3.493-18.2-13.806-62.856-13.806-62.856s-1.589-67.8-3.274-79.163-5.391-30.913-5.391-34.012,3.519-17.976,3.933-22.722c.817-9.362-.562-48.161-.562-48.161Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1285",
    "data-name": "Path 1285",
    d: "M634.271,675.184s14.39,45.6,15.461,50.248,7.721,25.42,10.949,33c1.438,3.379,10.563,17.034,11.635,21.165s7.64,39.2,11.927,50.047,23.431,49,23.967,58.295.379,23.315.379,23.315l11.185,40.71h29.093L732.32,905.5s-7.369-29.928-8.572-54.222c-.154-3.095-2.338-34.774-8.037-59.9-4.348-19.17-16.61-44.411-18.753-53.706s-3.75-68.682-3.75-68.682Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1286",
    "data-name": "Path 1286",
    d: "M705.92,879.344c-6.8-16.915-21.62-43.752-24.754-55.9s-9.768-43.639-10.888-45.894-9.869-16.278-12.785-25.521-14.475-48.905-14.475-48.905l51.1-6.052.946,19.308s-13.17,5.609-38.243,3.426c0,0,9.6,38.353,18.5,48.332C678.253,771.427,686.175,822.6,705.92,879.344Z",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1287",
    "data-name": "Path 1287",
    d: "M615.694,707.1s1.02,18.885,0,25.959c-.158,1.1-4.089,20.295-3.813,22.554s6.613,33.406,6.873,36.654,1.023,70.15,2.53,77.083,12.543,59.442,12.543,59.442L616.2,870.106l-4.483-81.618s-6.2-34.144-6.456-35.314-1.781-32.039-1.781-32.039-20.651,1.154-31.442-2.58l-1.886-15.427Z",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1288",
    "data-name": "Path 1288",
    d: "M571.175,753.65s-2.249,34.043.462,43.959S601.452,880.7,601.452,880.7s-22.9-84.5-23.41-86.37S571.175,753.65,571.175,753.65Z",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1289",
    "data-name": "Path 1289",
    d: "M697.559,739.868s15.638,38.284,19.308,51.777c4.429,16.289,7.869,73.372,9.193,81.579s6.26,32.277,6.26,32.277l3.854,10.821s-6.88-11.762-8.174-14.177-4.852-29.544-4.852-29.544-11.971-77.254-12.294-81.5S697.559,739.868,697.559,739.868Z",
    fill: "url(#linear-gradient-12)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1290",
    "data-name": "Path 1290",
    d: "M606.2,911.258l-2.627,43.819,30.317-.312.319-24.024-3.839,19.814s-22.9.468-23.066,0S606.2,911.258,606.2,911.258Z",
    fill: "url(#linear-gradient-13)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1291",
    "data-name": "Path 1291",
    d: "M606.2,911.258s-2.027,10.758-2.712,18.951-4.776,31.256-2.833,34.846,11.228,10.056,20.8,9.442c4.9-.315,14.068-6.576,15.237-9.676,1.264-3.35-1.017-22.568-2.479-34.08l-.644,21.7-29.027.42S607.338,926.8,606.2,911.258Z",
    fill: "url(#linear-gradient-14)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1292",
    "data-name": "Path 1292",
    d: "M708.594,902.145l.8,15.2,10.029,36.638L750,953.05l-13.826-36.728,8.594,32.922-22.753.22S710.216,914.383,708.594,902.145Z",
    fill: "url(#linear-gradient-15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1293",
    "data-name": "Path 1293",
    d: "M736.174,916.322l12.09,35.275-28.531-.1s-5.837-23.33-6.273-24.844c-3.028-10.508-4.022-14.337-4.866-24.511,0,0-1.9,10.76-1.7,12.278.77,6.1,4.443,9.955,6.187,22.561s2.12,25.466,3.579,26.8c3.778,3.448,25.523,8.5,33.424,8.041,5.426-.312,2.338-13.9.89-19.478C749.324,946,736.174,916.322,736.174,916.322Z",
    fill: "url(#linear-gradient-14)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_508",
    "data-name": "Group 508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_507",
    "data-name": "Group 507"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1294",
    "data-name": "Path 1294",
    d: "M694.935,322.164c-2.96-6.169-17.177-10.039-18.922-10.209-6.107-.589-30.821-2.52-33.371-10.675-3.17-10.146.612-23.153.612-23.153l-38.109-1.907c4.287,7.146,4.129,14.75,3.951,22.458-.2,8.465-25.829,14.43-34.635,15.4-4.816.531-21.795,6.13-24.138,14.416-3.292,11.639-3.036,15.526-2.057,30.809l153.363-14.7C700.69,336.1,700.582,333.932,694.935,322.164Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1295",
    "data-name": "Path 1295",
    d: "M661.372,310.517a30.262,30.262,0,0,0,3.954-2.131c-14.807-1.918-19.272-4.443-20.341-5.172-1.143-.779-2.242-4.469-2.651-8.783-.178-1.878-.454-6.589-.518-9.048-.519.635-33-.547-34.255-2.4l-3.774.035s1.113,11.95-.656,20.511c-.36,1.744-10.885,4.211-17.795,5.651.495.383,2.267,1.577,2.664,1.788,5.914.583,11,1.277,13.414.858,2.953-.512,7.921-2.766,11.515-4.414,19.479-8.927,25.556-11.877,25.556-11.877.915,8.3,7.051,13.791,6.719,13.711A64.471,64.471,0,0,0,661.372,310.517Z",
    fill: "url(#linear-gradient-17)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1296",
    "data-name": "Path 1296",
    d: "M630.345,322.579s-2.028-5.582-8.851-3.412C621.494,319.167,628.5,320.408,630.345,322.579Z",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1297",
    "data-name": "Path 1297",
    d: "M630.583,317.8s1.956-5.068,4.683-5.744,32.894-1.688,36.427-2.377c0,0-13.424,2.933-21.184,3.834S636.665,313.067,630.583,317.8Z",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1298",
    "data-name": "Path 1298",
    d: "M620.947,317.76s-1.888-3.885-5.243-5.014-28.995-2.716-33.61-2.265C582.094,310.481,614.445,313.725,620.947,317.76Z",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1299",
    "data-name": "Path 1299",
    d: "M603.878,298.112s-.451-16.546-1.137-20.217c0,0,38.19,1.376,39.924,1.53a73.936,73.936,0,0,0-.749,9.647S626.247,305.221,603.878,298.112Z",
    fill: "url(#linear-gradient-21)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1300",
    "data-name": "Path 1300",
    d: "M612.354,330.173s3.737-3.766,11.682,7.323c6.042,8.432,7.386,72.993,7.753,79.44,1.123,19.639-1.41,50.215-1.41,50.215l-22.035.766S592.51,324.912,591.015,323.042l7.855-6.734Z",
    fill: "#d4e1f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1301",
    "data-name": "Path 1301",
    d: "M594.026,307.181l3.941-1.091s2.891,4.972,5.928,7.226a181.957,181.957,0,0,1,14.285,12.809,75.822,75.822,0,0,1,6.084,8.113s11.882-12.317,13.782-14.105c3.376-3.177,8.477-8.178,11.657-14.874,0,0,3.588,1.023,4.239,1.15,0,0-16.262,19.173-16.885,20.528S623.2,342.212,623.2,342.212,594.764,311.053,594.026,307.181Z",
    fill: "url(#linear-gradient-22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1302",
    "data-name": "Path 1302",
    d: "M637.459,327.6s-9.551,4.716-13.423,9.895c-2.724,3.645-.581,127.667-.581,127.667s27.31,9.964,31.426-1.633,6.212-143.48,10.2-145.352l-11.721-7.48Z",
    fill: "#d4e1f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1303",
    "data-name": "Path 1303",
    d: "M612.11,325.628,624.036,337.5,626.91,461.7l-8.777.456s-2.929-107.876-3.474-110.843Z",
    fill: "url(#linear-gradient-23)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M610.1,407.851c.5.065,24.376,1.336,25.432.846v7.129l-25.083-2.647Z",
    fill: "url(#linear-gradient-24)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M593.132,330.316l2.82-3.877s13.807,47.251,14.1,49.346c1.5,10.762,6.562,54.281,3.8,89.378H609.6Z",
    fill: "url(#linear-gradient-25)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M652.346,324.325s-15.31,39.525-18.6,60.358c-5.294,33.491-.951,85.379-.951,85.379l8.59,2.631,14.6-148.653Z",
    fill: "url(#linear-gradient-26)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M609.7,456.916s20.77-1.449,27.279-2.14l.983,7.382s-25.427,1.1-29.575-1.739Z",
    fill: "#bfd3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1308",
    "data-name": "Path 1308",
    d: "M694.308,635.775c-.111-49.283-5.924-89.743-10.786-124.75-1.446-10.421-9.32-35.212-11.361-51.821-59.542,7.947-97.731-5.1-109.219-10.283l-.005.011c-22.071,41.864-21.85,64.125-20.356,94.522.441,8.979,8.574,101.5,8.73,106.642.354,11.569,0,53.632,0,53.632,4.99,6.86,31.76,9.819,37.419,9.878,8.616.089,44.973-.01,79.532-2.215,21.984-1.4,26.4-5.369,26.4-5.369C695.094,693.581,694.42,685.354,694.308,635.775Z",
    fill: "url(#linear-gradient-27)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1309",
    "data-name": "Path 1309",
    d: "M563.619,489.486c4.513-2.469,53.956,202.944,43.2,209.024s-40.676,2.747-41.143-4.737S538.829,503.05,563.619,489.486Z",
    fill: "url(#linear-gradient-28)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1310",
    "data-name": "Path 1310",
    d: "M604.536,459.641s10.839,1.527,19.04,1.783,16.286.2,20.785-.383l.783,18.53s-23.461,1.659-42.5-1.66Z",
    fill: "url(#linear-gradient-29)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1311",
    "data-name": "Path 1311",
    d: "M643.316,696.345c3.041,8.186,41.133,5.379,40.927,0-.379-9.866-7.9-153.538-14.45-161.021S639.6,686.328,643.316,696.345Z",
    fill: "url(#linear-gradient-30)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1312",
    "data-name": "Path 1312",
    d: "M651.765,712.29s-16.829-198.979-17-203.957-2.686-46.649-2.686-46.649,4.359-.065,10.257-.366l21.25,250.357Z",
    fill: "url(#linear-gradient-31)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1313",
    "data-name": "Path 1313",
    d: "M593.132,713.626s20.543-239.849,21.015-252.847a86.787,86.787,0,0,1-12.156-1.421L574.126,712.009A121.272,121.272,0,0,0,593.132,713.626Z",
    fill: "url(#linear-gradient-32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1314",
    "data-name": "Path 1314",
    d: "M665.326,308.386l33.324,8.767L688.1,371.036l-12.01,87.946s21.076,116.494,22.56,127.172,9.781,129.631,9.781,129.631-14.2,11.9-49.647,10.862c0,0-21.727-206.7-24.977-306.341C633.231,402.62,665.326,308.386,665.326,308.386Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1315",
    "data-name": "Path 1315",
    d: "M552.622,320.724l32.218-14.246,21.19,78.205s6.576,34.78,6.643,43.539-25.242,264.5-27.833,298.425c-33.773-3.978-42.071-8.662-45.8-10.862,0,0-2.141-129.2-1.933-135.7s5.359-80.344,6.534-84.933c6.038-23.584,16.693-49.733,16.693-49.733C570.458,370.234,552.622,320.724,552.622,320.724Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1316",
    "data-name": "Path 1316",
    d: "M678.631,351.872s-1.595,10.064-2.322,16.516c-1.771,15.718-1.3,26.548-2.355,32.662,0,0,6.972-7.732,7.213-9.733S681.542,325.839,678.631,351.872Z",
    fill: "url(#linear-gradient-33)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_520",
    "data-name": "Group 520"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1317",
    "data-name": "Path 1317",
    d: "M668.732,241.491c2.579-10.215,11.388-59.064-27.441-67.34-17.251-3.679-41.989,110.97.895,100.434C649.319,272.833,663.918,263.568,668.732,241.491Z",
    fill: "url(#linear-gradient-34)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1318",
    "data-name": "Path 1318",
    d: "M586.794,220.366s-12.7,10.012-14.947,20.191c.122.5,6.223,20.619,21.876,26.778,18.451,7.26,25.758-1.947,43.029-9.424C636.752,257.911,595.01,228.424,586.794,220.366Z",
    fill: "url(#linear-gradient-35)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1319",
    "data-name": "Path 1319",
    d: "M629.689,188.809c-24.577-3.7-43.132,16.02-46.924,43.358-3.358,24.207.611,34.7,13.985,45.319,8.533,6.775,17.372,17.254,26.275,17.352,12.2.135,18.553-10.306,21.869-13.155,9.478-8.154,23.087-13.157,18.553-46.167C660.062,210.892,650.5,188.428,629.689,188.809Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1320",
    "data-name": "Path 1320",
    d: "M619.927,253.168c-1.91-10.8-.039-29.586-20.134-31.2a16.548,16.548,0,0,0-12.582,4.525c-6.592,5.81-2.536,20.315-2.536,20.315S597.925,263.309,619.927,253.168Z",
    fill: "url(#linear-gradient-36)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1321",
    "data-name": "Path 1321",
    d: "M625.854,252.854c1.66-10.106,1.337-27.839,19.391-29.855,5.633-.629,9.913.365,12.874,2.455,7.966,5.622,4.49,19.294,4.49,19.294S648.046,261.251,625.854,252.854Z",
    fill: "url(#linear-gradient-37)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1322",
    "data-name": "Path 1322",
    d: "M664.023,247.885s2.384-50-31.8-60.917c0,0-27.445-7.274-39.7,13.251-11.8,19.754-9.648,40.391-11.032,55.169,0,0,2.293-3.258,3.662-13.456a50.839,50.839,0,0,1,16.013-31.074c6.3-5.23,15.762-15.678,29.364-19.389,3.675-.316,11.611,1.76,17.975,12.178C659.2,221.177,656.014,231.17,664.023,247.885Z",
    fill: "#f0c499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1323",
    "data-name": "Path 1323",
    d: "M636.912,256.835c1.547,7.141,6.173,13.192,12.324,15.564,8.035,3.1,13.615-7.69,14.723-20.919.609-7.277-9.616-12.419-16.008-10.908S635.37,249.7,636.912,256.835Z",
    fill: "url(#radial-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1324",
    "data-name": "Path 1324",
    d: "M655.618,247.062c-2.17.622-3.668,2.124-3.344,3.357s2.345,1.735,4.513,1.114,3.668-2.12,3.345-3.356S657.783,246.442,655.618,247.062Z",
    fill: "url(#linear-gradient-38)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1325",
    "data-name": "Path 1325",
    d: "M627.745,186.981c13.616-2.163,18.131-9,13.609-12.8-16.6-13.964-58.356-11.724-71.731,32.8-3.351,15.441.085,30.906,2.856,39.357.907-3.92,5.166-10.3,8.3-15.452a157.233,157.233,0,0,1,12.05-16.415C603.747,200.706,617.457,192.556,627.745,186.981Z",
    fill: "url(#linear-gradient-39)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1326",
    "data-name": "Path 1326",
    d: "M629.651,186.874a31.886,31.886,0,0,1,6.894-.565c4.229.326,13.826,5.775,21.434,21.958,4.424,9.4,5.919,19.653,10.278,31.9-6.356,11.881-4.328-6.01-7.238-16-1.7-5.852-3.629-13.487-10.609-23.485C647.5,196.523,640.646,187.382,629.651,186.874Z",
    fill: "url(#linear-gradient-40)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1327",
    "data-name": "Path 1327",
    d: "M609.136,257.588c-1.362,6.17-5.419,17.216-11.432,16.419-7.762-1.027-13.664-5.3-14.26-20.272-.254-6.34,8.922-11.114,14.824-9.7S610.5,251.411,609.136,257.588Z",
    fill: "url(#radial-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1328",
    "data-name": "Path 1328",
    d: "M590.207,248.844c-2.195-.388-4.14.311-4.343,1.557s1.41,2.577,3.607,2.971,4.14-.311,4.344-1.558S592.4,249.233,590.207,248.844Z",
    fill: "url(#linear-gradient-41)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1329",
    "data-name": "Path 1329",
    d: "M630.914,186.682s-11.573,1.279-33.008,22.49c-3.956,3.914-11.762,10.645-19.1,31.287-.316-1.221-3.8,3.3-3.721,1.659.815-15.768,13.12-31.017,22.182-39.153C607.423,193.848,623.316,180.564,630.914,186.682Z",
    fill: "url(#linear-gradient-42)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_509",
    "data-name": "Group 509"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1330",
    "data-name": "Path 1330",
    d: "M570.225,229.242a43.8,43.8,0,0,1,1.592-12.643,51.781,51.781,0,0,1,17.558-26.8c10.057-8.05,21.651-11.536,29.45-10.576a18.569,18.569,0,0,1,11.3,5.642c-.056-.066-4.116-3.254-13.306-1.672-7.2,1.238-13.6,6.2-22.1,12.8a75.8,75.8,0,0,0-18.866,21.313A76.954,76.954,0,0,0,570.225,229.242Z",
    fill: "url(#linear-gradient-43)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_510",
    "data-name": "Group 510"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1331",
    "data-name": "Path 1331",
    d: "M585.64,283.169a36.331,36.331,0,0,0-1.589-11.04c-1.076-3.233-3.274-6.377-6.215-10.266-2.927-3.807-6.065-9.467-6.581-15.893a31.33,31.33,0,0,1,2.945-17.024,46.787,46.787,0,0,1,7.663-10.89,91.474,91.474,0,0,1,8.638-8.228,101.887,101.887,0,0,0-7.3,10.559c-3.619,6.12-7.167,14.289-6.067,24.327a30.751,30.751,0,0,0,4.273,13.262c2.295,4.037,4.684,8.4,5.287,12.45A27.176,27.176,0,0,1,585.64,283.169Z",
    fill: "url(#linear-gradient-44)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_511",
    "data-name": "Group 511"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1332",
    "data-name": "Path 1332",
    d: "M663.647,241.249c-1.578,12.515-2.028,22.038-2.028,22.038,5.13,0,6.139-5.365,8.142-10.094,3.064-7.228,4.872-14.98-2.1-15.395C666.3,237.717,663.647,241.249,663.647,241.249Z",
    fill: "#f0c499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1333",
    "data-name": "Path 1333",
    d: "M664.578,259.078s2.512-2.772,1.732-8.225c-1.836-12.868,6.525-13.749,4.626-4.966,0,0-1.155-4.142-2.213-2.9-1.3,1.522,1.395,2.36.018,9C668.025,255.437,664.578,259.078,664.578,259.078Z",
    fill: "url(#linear-gradient-45)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_512",
    "data-name": "Group 512"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1334",
    "data-name": "Path 1334",
    d: "M582.832,241.269c1.578,12.516,2.028,22.038,2.028,22.038-5.129,0-6.139-5.365-8.142-10.093-3.064-7.229-4.724-15.014,3.345-15.7C581.42,237.4,582.832,241.269,582.832,241.269Z",
    fill: "#f0c499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1335",
    "data-name": "Path 1335",
    d: "M581.9,259.1s-2.512-2.773-1.732-8.225c1.836-12.869-6.525-13.749-4.626-4.967,0,0,1.155-4.141,2.213-2.9,1.3,1.522-1.395,2.36-.018,9C578.454,255.457,581.9,259.1,581.9,259.1Z",
    fill: "url(#linear-gradient-46)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1336",
    "data-name": "Path 1336",
    d: "M661.209,224.776s1.607,18.986,2.8,23.742l.624-8.474S662.446,227.234,661.209,224.776Z",
    fill: "url(#linear-gradient-47)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_513",
    "data-name": "Group 513"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1337",
    "data-name": "Path 1337",
    d: "M669.327,230.082a58.57,58.57,0,0,1-4.232-8.646c-2.4-5.5-5.2-13.4-9.3-21.391-3.926-7.992-8.91-13.942-14.332-15.153a17.8,17.8,0,0,0-9.492.223c.211-.058,3.076-2.4,9.43-2.662A18.008,18.008,0,0,1,652.01,186a30.459,30.459,0,0,1,8.757,10.553c4.439,8.421,5.932,17.054,6.973,23.246C668.664,226.032,669.27,230.028,669.327,230.082Z",
    fill: "url(#linear-gradient-48)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1338",
    "data-name": "Path 1338",
    d: "M584.86,226.388s-1.635,16.406-2.834,22.13l-.664-10.108,1.725-8.639Z",
    fill: "url(#linear-gradient-49)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1339",
    "data-name": "Path 1339",
    d: "M569.588,207.139c3.024-14.555,13.676-26.692,20.732-31.722,17.182-12.247,37.638-10.881,51.092-5.576a45.258,45.258,0,0,1,28.61,34.469s-12.884-27.859-36.354-31.371c-5.5-.824-20.776-1.723-34.614,3.375C584.21,181.783,574.888,194.231,569.588,207.139Z",
    fill: "url(#linear-gradient-50)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_519",
    "data-name": "Group 519"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_514",
    "data-name": "Group 514"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1340",
    "data-name": "Path 1340",
    d: "M603.7,267.2c-1.03-.345-1.6-1.171-1.175-1.962.381-.707,4.72,2.362,6.389,4.765A19.1,19.1,0,0,0,603.7,267.2Z",
    fill: "url(#linear-gradient-51)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1341",
    "data-name": "Path 1341",
    d: "M642.207,266.877c1-.419,1.517-1.285,1.029-2.042-.43-.677-4.534,2.7-6.021,5.215A19.036,19.036,0,0,1,642.207,266.877Z",
    fill: "url(#linear-gradient-52)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1342",
    "data-name": "Path 1342",
    d: "M612.939,275.306c1.948,4.167,12.662,9.97,20.571-.1C633.51,275.2,622.277,280.224,612.939,275.306Z",
    fill: "#f0c499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1343",
    "data-name": "Path 1343",
    d: "M621.986,268.18a81.57,81.57,0,0,1-18.359-2.14l-.005.023a2.514,2.514,0,0,1,.176.254,20.218,20.218,0,0,1,4.58,2.269c1.275.92,2.53,7.127,15.079,6.984,6.854-.08,10.993-2.423,15.038-7.117a10.868,10.868,0,0,1,3.463-2.5c.025-.114.081-.164.109-.284C639.319,266.449,633.8,268.311,621.986,268.18Z",
    fill: "#961b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1344",
    "data-name": "Path 1344",
    d: "M633.29,269.282a63.768,63.768,0,0,1-20.093.765c-2.019-.891-1.818,1.672-1.818,1.672,4.413,4.522,7.956,3.669,11.506,3.754,3.5.093,8.73-1.323,11.833-4.09C635.019,270.548,634.271,269.06,633.29,269.282Z",
    fill: "url(#linear-gradient-53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1345",
    "data-name": "Path 1345",
    d: "M636.41,266.669s-2.3,1.12-7.689,1.693c-5.443.58-7.736.253-12.625.024a31.065,31.065,0,0,1-6.428-1.1,6.937,6.937,0,0,1,.851,1.4c.429.985,2.553,4.322,12.656,4.193,7.6-.1,11.6-2.807,12.142-4.448C635.644,267.442,636.35,267,636.41,266.669Z",
    fill: "url(#linear-gradient-54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1346",
    "data-name": "Path 1346",
    d: "M624.131,275.11c-15.433-.009-10.072-6.316-20.333-8.793a19,19,0,0,1,5.066,4.377c2.984,3.444,5.556,8.873,14.2,8.8,7.8-.078,12.1-5.761,14.589-8.884,2.85-3.571,4.273-4.638,4.337-4.655C633.618,268.246,636.4,274.718,624.131,275.11Z",
    fill: "#f86d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1347",
    "data-name": "Path 1347",
    d: "M615,273.691c-2.374-1.215-4.493-3.8-4.938-4.13.559.756,3.907,8.931,12.6,8.737,10.048-.225,11.857-6.971,13.65-8.977-.848.895-2.974,3.3-5.6,4.209a29.342,29.342,0,0,1-7.879,1.454A21.1,21.1,0,0,1,615,273.691Z",
    fill: "url(#linear-gradient-55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1348",
    "data-name": "Path 1348",
    d: "M630.409,274.538c.131.352-.832,1.525-2.88,2.1-2.633.742-4.72.034-4.856-.32s3.361-.6,4.376-.952S630.275,274.188,630.409,274.538Z",
    fill: "#ff9aa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1349",
    "data-name": "Path 1349",
    d: "M603.964,266.915c.613.277,1.082-.187,3.5.69,0,0-4.125-2.146-4.4-2.023C602.879,265.668,603.063,266.5,603.964,266.915Z",
    fill: "#961b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1350",
    "data-name": "Path 1350",
    d: "M642,266.563c-.605.292-1.281-.152-3.393.8,0,0,3.924-2.374,4.262-2.147C643.046,265.33,642.9,266.135,642,266.563Z",
    fill: "#961b27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1351",
    "data-name": "Path 1351",
    d: "M609.883,267.528l.656,1.2s4.374,2.348,13.349,2.314a28.077,28.077,0,0,0,11.391-2.5l.512-1.195Z",
    fill: "url(#linear-gradient-56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1352",
    "data-name": "Path 1352",
    d: "M628.759,266.642c-3-.234-3.335.258-5.488.278-2.1.019-3.789-.6-6.388-.361a40.76,40.76,0,0,1-12.428-.45s1.825,1.121,10.872,2.864a35.772,35.772,0,0,0,7.85.966,46.313,46.313,0,0,0,8.623-1.113,43.358,43.358,0,0,0,9.508-3C638.989,266.482,632.071,266.893,628.759,266.642Z",
    fill: "#f86d78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1353",
    "data-name": "Path 1353",
    d: "M613.3,267.529c.086-.315,4.578-.711,5.316-.71s3.2.431,4.085.434a35.457,35.457,0,0,0,4.333-.332c.737-.168,6.2.311,6.149.691s-7.975,1.341-8.91,1.424S613.051,268.462,613.3,267.529Z",
    fill: "url(#linear-gradient-57)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1354",
    "data-name": "Path 1354",
    d: "M645.405,223.028s5.813-1.146,13.259,3.587c4.333,2.754.581,14.1.581,14.1S661.675,226.615,645.405,223.028Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1355",
    "data-name": "Path 1355",
    d: "M637.592,224.027c-3.031,1.438-5.206,5.467-2.573,4.594s12.353-4.6,14.478-4.647a23.285,23.285,0,0,1,9.455,2.475s-5.9-4.619-9.531-4.991S639.223,223.255,637.592,224.027Z",
    fill: "url(#linear-gradient-58)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1356",
    "data-name": "Path 1356",
    d: "M608.229,224.141c-1.664-.694-8.849-2.888-12.45-2.343s-9.286,5.521-9.286,5.521c1.247-.863,6.323-3.086,9.33-3,2.121.059,12.009,3.278,14.676,4.027S611.327,225.434,608.229,224.141Z",
    fill: "url(#linear-gradient-59)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_515",
    "data-name": "Group 515"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1357",
    "data-name": "Path 1357",
    d: "M598.513,230.367c-3.047.252-9.523,1.36-9.44,7.09.1,7.243,7.643,8.966,11.01,8.994,4.278.041,7.246-1.213,9.777-1.994,1.874-.578,2.879-.762,3.833-.975C613.432,237.918,611.124,230.367,598.513,230.367Z",
    fill: "url(#linear-gradient-60)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1358",
    "data-name": "Path 1358",
    d: "M605.989,234.747a8.849,8.849,0,0,1,2.865,5.277,5.6,5.6,0,0,1-2.238,4.877c1.912-.517,3.75-1.46,6.5-1.853C613.121,243.048,610.454,237.384,605.989,234.747Z",
    fill: "url(#linear-gradient-61)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1359",
    "data-name": "Path 1359",
    d: "M606.358,235.569a6.238,6.238,0,0,1,2.379,3.832,21.809,21.809,0,0,1,4.384,3.647S610.442,237.555,606.358,235.569Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1360",
    "data-name": "Path 1360",
    d: "M600.787,233.6c-3.107.277-6.879,1.865-11.43,5.642a12.885,12.885,0,0,0,9.957,6.393,6.064,6.064,0,0,1-3.083-4.967A7.019,7.019,0,0,1,600.787,233.6Z",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1361",
    "data-name": "Path 1361",
    d: "M608.752,239.24a14.177,14.177,0,0,0-12.681-1.752,6.689,6.689,0,0,0-.661,3.327c.133,2.28,1.438,3.7,3.244,4.81a22.129,22.129,0,0,0,7.962-.724,5.347,5.347,0,0,0,2.238-4.877A7.076,7.076,0,0,0,608.752,239.24Z",
    fill: "url(#linear-gradient-63)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1362",
    "data-name": "Path 1362",
    d: "M590.545,239.426l.874,1.6a18.67,18.67,0,0,1,4.274-2.471,6.326,6.326,0,0,1,2.977-3.562A13.534,13.534,0,0,0,590.545,239.426Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1363",
    "data-name": "Path 1363",
    d: "M606.358,235.569a6.99,6.99,0,0,0-1.755-.6,16.173,16.173,0,0,0-5.933.026,6.159,6.159,0,0,0-3.015,3.577,14.567,14.567,0,0,1,6.865-1.19,14.865,14.865,0,0,1,6.261,2.019A6.124,6.124,0,0,0,606.358,235.569Z",
    fill: "url(#linear-gradient-64)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1364",
    "data-name": "Path 1364",
    d: "M601.936,235.4a4.093,4.093,0,1,0,4.524,3.763A4.164,4.164,0,0,0,601.936,235.4Z",
    fill: "url(#radial-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1365",
    "data-name": "Path 1365",
    d: "M603.115,237.907a1.149,1.149,0,0,0-1.554.551,1.206,1.206,0,0,0,.505,1.6,1.15,1.15,0,0,0,1.554-.553A1.208,1.208,0,0,0,603.115,237.907Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1366",
    "data-name": "Path 1366",
    d: "M606.983,239.516a1.594,1.594,0,0,0-2.135.7,1.568,1.568,0,0,0,.72,2.111,1.6,1.6,0,0,0,2.138-.7A1.565,1.565,0,0,0,606.983,239.516Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1367",
    "data-name": "Path 1367",
    d: "M593.992,233.85a8.807,8.807,0,0,1-7.48.225c.03.166-.523,4.6,2.719,5.726a4.548,4.548,0,0,0,.111.467,2.225,2.225,0,0,0-2.146,1.059c.012.027,1.331-.7,4.24,1.406a15.44,15.44,0,0,0,8.045,2.994c-4.271-1.657-6.346-2.655-8.572-6.111a16.486,16.486,0,0,1,11.751-3.854c5.942.328,10.461,7.286,10.461,7.286C611.192,235.485,605.209,229.328,593.992,233.85Z",
    fill: "url(#linear-gradient-65)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1368",
    "data-name": "Path 1368",
    d: "M605.138,231.016a17.385,17.385,0,0,0-11.347.328s6.636-1.25,11.1.457a18.3,18.3,0,0,1,6.276,3.584A12.312,12.312,0,0,0,605.138,231.016Z",
    fill: "url(#linear-gradient-66)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1369",
    "data-name": "Path 1369",
    d: "M603.469,235.137c-9.678-.981-12.56,4.479-12.56,4.479a17.414,17.414,0,0,1,12.251-3.81c5.482.52,9.961,7.242,9.961,7.242S610.688,235.868,603.469,235.137Z",
    fill: "#391b13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_517",
    "data-name": "Group 517"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1370",
    "data-name": "Path 1370",
    d: "M615.583,259.307s6.5,4.338,7.955,4.147,7.484-4.14,7.484-4.14Z",
    fill: "url(#linear-gradient-67)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_516",
    "data-name": "Group 516"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1371",
    "data-name": "Path 1371",
    d: "M623.323,252.859c-4.095.112-5.254,1.15-4.954,2.244.732,2.658,2.471,3.157,5.03,3.15,2.694-.008,4.8-.6,5.21-3.467C628.732,253.94,627.426,252.745,623.323,252.859Z",
    fill: "url(#linear-gradient-68)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1372",
    "data-name": "Path 1372",
    d: "M626.076,260s4.276-3.2,5.094-2.366C633.6,260.119,626.076,260,626.076,260Z",
    fill: "url(#linear-gradient-69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1373",
    "data-name": "Path 1373",
    d: "M621.025,260s-4.529-2.78-5.415-2.027C613.1,260.11,621.025,260,621.025,260Z",
    fill: "url(#linear-gradient-70)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1374",
    "data-name": "Path 1374",
    d: "M615.583,259.307s-.437-1.1,1.273-.985c1.237.08,2.227,2.71,6.631,2.584,4.7-.135,5.343-2.5,6.552-2.561a.854.854,0,0,1,.983.969s2.229-1.153,1.386-2.183c-1.532-1.875-2,1.974-9.021,1.878-7.624-.11-8.494-3.838-9.53-1.446C613.431,258.543,614.243,258.835,615.583,259.307Z",
    fill: "#f0c499"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_518",
    "data-name": "Group 518"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1375",
    "data-name": "Path 1375",
    d: "M647.7,229.931c-12.612,0-14.919,7.551-15.18,13.115.954.213,1.958.4,3.833.975,2.531.782,5.5,2.035,9.777,1.994,3.367-.028,10.906-1.751,11.01-8.994C657.222,231.291,650.745,230.183,647.7,229.931Z",
    fill: "url(#linear-gradient-71)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1376",
    "data-name": "Path 1376",
    d: "M633.091,242.612c2.754.393,4.593,1.336,6.505,1.853a5.6,5.6,0,0,1-2.238-4.877,8.853,8.853,0,0,1,2.864-5.277C635.758,236.949,633.091,242.612,633.091,242.612Z",
    fill: "url(#linear-gradient-72)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1377",
    "data-name": "Path 1377",
    d: "M633.091,242.612a21.825,21.825,0,0,1,4.383-3.647,6.244,6.244,0,0,1,2.38-3.832C635.77,237.119,633.091,242.612,633.091,242.612Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1378",
    "data-name": "Path 1378",
    d: "M649.98,240.232A6.061,6.061,0,0,1,646.9,245.2a12.885,12.885,0,0,0,9.958-6.393c-4.551-3.777-8.323-5.365-11.43-5.642A7.017,7.017,0,0,1,649.98,240.232Z",
    fill: "url(#linear-gradient-62)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1379",
    "data-name": "Path 1379",
    d: "M637.46,238.8a7.142,7.142,0,0,0-.1.785,5.345,5.345,0,0,0,2.238,4.877,22.132,22.132,0,0,0,7.963.724,5.882,5.882,0,0,0,3.242-4.81,6.684,6.684,0,0,0-.66-3.328A14.183,14.183,0,0,0,637.46,238.8Z",
    fill: "url(#linear-gradient-74)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1380",
    "data-name": "Path 1380",
    d: "M647.542,234.559a6.326,6.326,0,0,1,2.977,3.562,18.672,18.672,0,0,1,4.274,2.471l.874-1.6A13.538,13.538,0,0,0,647.542,234.559Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1381",
    "data-name": "Path 1381",
    d: "M647.542,234.559a16.151,16.151,0,0,0-5.933-.026,6.991,6.991,0,0,0-1.755.6,6.12,6.12,0,0,0-2.423,3.832,14.86,14.86,0,0,1,6.261-2.019,14.561,14.561,0,0,1,6.864,1.19A6.158,6.158,0,0,0,647.542,234.559Z",
    fill: "url(#linear-gradient-75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1382",
    "data-name": "Path 1382",
    d: "M644.276,234.962a4.093,4.093,0,1,0,3.919,4.393A4.156,4.156,0,0,0,644.276,234.962Z",
    fill: "url(#radial-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1383",
    "data-name": "Path 1383",
    d: "M645,237.371a1.208,1.208,0,0,0-1.621.452,1.15,1.15,0,0,0,.387,1.6,1.208,1.208,0,0,0,1.618-.452A1.149,1.149,0,0,0,645,237.371Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1384",
    "data-name": "Path 1384",
    d: "M648.81,239.07a1.569,1.569,0,0,0-2.162.549,1.6,1.6,0,0,0,.581,2.17,1.566,1.566,0,0,0,2.161-.545A1.6,1.6,0,0,0,648.81,239.07Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1385",
    "data-name": "Path 1385",
    d: "M659.7,233.639a8.808,8.808,0,0,1-7.48-.225c-11.217-4.522-17.2,1.635-19.129,9.2,0,0,4.519-6.958,10.461-7.286A16.486,16.486,0,0,1,655.3,239.18c-2.226,3.456-4.3,4.454-8.572,6.111a15.435,15.435,0,0,0,8.045-2.994c2.909-2.109,4.228-1.379,4.24-1.406a2.228,2.228,0,0,0-2.146-1.059,4.445,4.445,0,0,0,.11-.467C660.222,238.239,659.67,233.8,659.7,233.639Z",
    fill: "url(#linear-gradient-76)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1386",
    "data-name": "Path 1386",
    d: "M641.074,230.58a12.312,12.312,0,0,0-6.029,4.369,18.283,18.283,0,0,1,6.275-3.584c4.465-1.707,11.1-.457,11.1-.457A17.385,17.385,0,0,0,641.074,230.58Z",
    fill: "url(#linear-gradient-77)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1387",
    "data-name": "Path 1387",
    d: "M642.742,234.7c-7.218.731-9.651,7.911-9.651,7.911s4.479-6.722,9.961-7.242a17.414,17.414,0,0,1,12.251,3.81S652.421,233.72,642.742,234.7Z",
    fill: "#391b13"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1388",
    "data-name": "Path 1388",
    d: "M664,247.972s-1.2-5.066-5.385-7.194c7.437,12.318.544,27.211-6.815,33.881-8.122,7.362-9.377,9.735-12.233,12.626,0,0,10.969-10,14.51-12.557C656.913,272.68,666.5,262.038,664,247.972Z",
    fill: "url(#linear-gradient-78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1389",
    "data-name": "Path 1389",
    d: "M585.2,241.856s-5.077,21.227,10.586,33.421c8.622,6.713,12.007,11.741,13.4,12.932-2.681-2.129-10.2-8.731-16.022-12.985C590.337,273.158,576.586,263.345,585.2,241.856Z",
    fill: "#f0c499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1390",
    "data-name": "Path 1390",
    d: "M611.243,289.808s11.245,13.5,25.9-.3C637.147,289.505,623.955,299.914,611.243,289.808Z",
    fill: "url(#linear-gradient-79)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1391",
    "data-name": "Path 1391",
    d: "M624.362,283.348c-3.034-.163-5.595.6-5.713,1.7s2.232,2.136,5.269,2.3,5.586-.6,5.71-1.7S627.388,283.509,624.362,283.348Z",
    fill: "url(#linear-gradient-80)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1392",
    "data-name": "Path 1392",
    d: "M667.135,232.769c-.006-.459.3-3.612-1.147-3.6s-24.034.616-27.613,1.017c-6.761.754-10.531,3.579-11.25,3.727a74.954,74.954,0,0,1-8.017.044c-.725-.14-4.686-2.92-11.49-3.6-3.6-.36-26.737-.721-28.178-.713s-.852,3.171-.83,3.621c.052,1.054,1.453,1.138,2.2,2.14s4.031,14.444,6.964,16.149,18.823,4.713,24.185.659,5.889-13.1,8.156-14.4,3.444-1.319,5.788-.037,3.66,10.34,9.256,14.331,21.252.879,24.082-.861,5.119-15.288,5.811-16.3S667.146,233.6,667.135,232.769Zm-56.923,18.586c-5.69,2.616-20.01.617-21.812-1.814s-5.222-13.028-2.256-15.2,16.535-1.85,20-1.58,8.49,1.753,9.488,3.325C616.995,238.237,615.908,248.74,610.212,251.355Zm48.3-2.132c-1.663,2.452-15.8,4.557-21.646,2s-7.746-13.062-6.51-15.222c.9-1.58,5.809-3.122,9.262-3.426s17-1.738,20.087.4S660.166,246.771,658.508,249.223Z",
    fill: "url(#linear-gradient-81)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1393",
    "data-name": "Path 1393",
    d: "M601.636,318.086c-2.228-1.083-9.476-6.266-9.476-6.266l-12.344,11.471,5.866,21.946,16.245-20.562s18.339,9.267,22.109,12.821C624.036,337.5,608.369,321.359,601.636,318.086Z",
    fill: "url(#linear-gradient-82)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1394",
    "data-name": "Path 1394",
    d: "M624.036,337.5s-20.156-16.942-21.652-16.948-7.357,5.736-7.357,5.736-3.484,6.733-12.712,18.953c0,0-5.171-23.433-3.373-26.31,8.729-13.966,15.025-17.582,15.025-17.582a23.8,23.8,0,0,0,9.405,14.513C605.946,317.747,620.131,329.465,624.036,337.5Z",
    fill: "url(#linear-gradient-83)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1395",
    "data-name": "Path 1395",
    d: "M649.294,313.316s-21.619,18.755-25.258,24.18c0,0,21.713-13.705,23.707-13.456l13.89,20.075,5.867-22.57Z",
    fill: "url(#linear-gradient-84)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1396",
    "data-name": "Path 1396",
    d: "M624.036,337.5s21.393-17.945,22.889-17.945,5.736,4.489,5.736,4.489,9.455,14.215,12.946,18.7c0,0,4.764-22.032,3.015-24.938-7.839-13.021-15.832-17.493-15.832-17.493s-.877,9.762-7.36,15.248C642.99,317.623,624.537,335.252,624.036,337.5Z",
    fill: "url(#linear-gradient-85)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1397",
    "data-name": "Path 1397",
    d: "M638.6,389.531,668.207,313.4s11.632,20.443,15.509,21.5c0,0-13.746,2.467-17.976,2.467L681.249,349.7s-46.507,44.8-47.4,74.214Z",
    fill: "url(#linear-gradient-86)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1398",
    "data-name": "Path 1398",
    d: "M560.493,444.185s4.553-34.571.4-84.812c0,0,6.152,15.493,10.175,25.12S560.493,444.185,560.493,444.185Z",
    fill: "url(#linear-gradient-87)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1399",
    "data-name": "Path 1399",
    d: "M607.583,397.286l-27.859-83.057s-11.9,20.288-15.79,21.293c0,0,13.713,2.649,17.941,2.7l-15.669,12.13s38.708,42.7,46.413,74.834Z",
    fill: "url(#linear-gradient-88)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_521",
    "data-name": "Group 521"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1400",
    "data-name": "Path 1400",
    d: "M573.772,523.537s1.9,64.8-3.093,66.246c-3.835,1.107-24.783-6.423-33.576-9.7.446-19.545,2.618-47.225,4.477-63.732Z",
    fill: "url(#linear-gradient-89)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1401",
    "data-name": "Path 1401",
    d: "M541.383,518.122c.066-.694.181-1.438.214-1.984,9.115,1.579,25.871,4.809,32.188,7.532C573.785,523.67,553.149,522.025,541.383,518.122Z",
    fill: "url(#linear-gradient-90)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1402",
    "data-name": "Path 1402",
    d: "M654.881,522.38s4.934,64.642,10.048,65.551c3.931.7,23.533-8.415,31.932-12.6-3.453-21.313-7.133-40.354-11.148-62.906Z",
    fill: "url(#linear-gradient-91)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1403",
    "data-name": "Path 1403",
    d: "M685.974,513.877c-.116-.661-.282-1.48-.381-2.124-8.9,2.529-24.716,7.387-30.712,10.76C654.881,522.513,674.683,519,685.974,513.877Z",
    fill: "url(#linear-gradient-92)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1404",
    "data-name": "Path 1404",
    d: "M565.436,723.848s13.38,2.863,19.4,2.8l15.276-162.429Z",
    fill: "url(#linear-gradient-93)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1405",
    "data-name": "Path 1405",
    d: "M658.784,726.647s14.8.064,19.014-.758l-35.16-170.831S652.466,667.845,658.784,726.647Z",
    fill: "url(#linear-gradient-94)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1406",
    "data-name": "Path 1406",
    d: "M655.631,455.612c9.43,1.5,8.676.9,20.459,3.37l2.229-13.915H638.492l-3.544,2.052.87,15.039A123.949,123.949,0,0,1,655.631,455.612Z",
    fill: "url(#linear-gradient-95)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_523",
    "data-name": "Group 523"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1407",
    "data-name": "Path 1407",
    d: "M654.53,427.1s-29.267.791-38.821.228c-11.867-.7-44.571-5.66-53.911-1.852s-21.731,30.234-6.228,32.368,66.085-3.339,98.925-10.6Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1408",
    "data-name": "Path 1408",
    d: "M658.444,441.621c.3-.1,1.224,2.032,2.144,1.913a9.325,9.325,0,0,0-.385,1.979,10.194,10.194,0,0,0-.007,1.581,130.77,130.77,0,0,0-19.179,3.126c-10.892,2.345-41.9,6.314-41.9,6.314l-1.349-3.673C599.607,452.975,656.148,442.332,658.444,441.621Z",
    fill: "url(#linear-gradient-96)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1409",
    "data-name": "Path 1409",
    d: "M556.2,454.264l-4.243,13.653a449.317,449.317,0,0,0,57.686-4.152c.455-4.124,1.146-13.144,1.146-13.144Z",
    fill: "url(#linear-gradient-97)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1410",
    "data-name": "Path 1410",
    d: "M552.622,320.724c-3.567,1.3-5.1,4.384-6.482,18.535s.374,28.018.007,33.682-3.439,31.762-3.9,48.441-.291,31.789,4.087,34.977,33.951,5.032,39.62,4.769,53.231-3.606,53.231-3.606l.256-28.015s-59.419-8.1-61.939-8.12-2.124-43.144-2.711-47.871-1.3-20.669-4.67-30.773C565.768,329.707,557.643,318.9,552.622,320.724Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1411",
    "data-name": "Path 1411",
    d: "M548.4,325.628c6.461-17.135,10.405,50.535,8.009,56.861-3.232,8.524-9.683-.756-10.527-17.8C545.406,355.133,544.641,335.616,548.4,325.628Z",
    fill: "url(#linear-gradient-98)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1412",
    "data-name": "Path 1412",
    d: "M610.1,407.851l-.176,8.4s-15.533-.852-16.783-1.808S573.5,393.965,573.5,393.965l.532-6.762s19.206,17.016,21.234,18.923S610.1,407.851,610.1,407.851Z",
    fill: "url(#linear-gradient-99)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1413",
    "data-name": "Path 1413",
    d: "M575.82,397.371s-2.414-46.459-4.014-54.327c-1.329-6.54-4.712,40.383-4.712,40.383Z",
    fill: "url(#linear-gradient-100)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1414",
    "data-name": "Path 1414",
    d: "M635.534,408.7l.414,6.3s29.1,1.525,30.051,1.218,12.132-18.619,12.309-20.822-1.824-6.94-1.824-6.94-9.178,18-11.2,19.414C663.07,409.419,641.67,408.911,635.534,408.7Z",
    fill: "url(#linear-gradient-101)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1415",
    "data-name": "Path 1415",
    d: "M544.028,415.566s3.111.643,8.945-4.037c0,0,7.49,3.075,10.329,3.1,0,0,3.291,5.542,4.283,6.387s-11.178,17.1-6.476,14.139,8.923-7.437,11.759-7.078,10.338,1.935,13.347,1.626,13.148,5.3,13.148,5.3l6.162,2.458-.519,4.952L639.267,449l.445-9.359s-45.674-24.9-48.835-26.429-35.389-39.244-36.051-39.919l-.662-.673s-2.193,2.152,1.272,7.027a102.022,102.022,0,0,0,6.776,7.913s-17.207,2.981-17.892,4.56c-.139.326-.311,3.323-.311,3.323a14,14,0,0,0,6.631-2.755c.492-.375,2.056.464,5.4.439.506,0,1.973,3.525,7.58,5.582,5.371,1.971-10.181-1.206-11.521-.718s-8.739,4.977-8.739,4.977l-.289,3.677s4.156.378,9.658-4.3c.529-.453,4.538,2.769,11.594,4.671s-10.63-.655-12.477.5S543.2,414.558,544.028,415.566Z",
    fill: "url(#linear-gradient-102)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1416",
    "data-name": "Path 1416",
    d: "M595.993,413.926l58.189,5.763-1.456,25.378-59.307-17.356Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_526",
    "data-name": "Group 526"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_524",
    "data-name": "Group 524"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1417",
    "data-name": "Path 1417",
    d: "M580.613,369.387s9.832,41.431-15.887,42.591c0,0-1.34,2.221,2.38,2.336s24.652-5.548,16.254-45.5Z",
    fill: "url(#linear-gradient-103)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1418",
    "data-name": "Path 1418",
    d: "M568.106,372.931s12.034,40.848,34.935,29.085c0,0,2.264,1.262-.907,3.211s-24.15,7.423-36.7-31.429Z",
    fill: "url(#linear-gradient-104)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1419",
    "data-name": "Path 1419",
    d: "M601.081,403s2.374-2.539,3.18-2.163,1.96,3.505,1.628,4.013-2.867.785-3.856.6A9.819,9.819,0,0,1,601.081,403Z",
    fill: "#022d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1420",
    "data-name": "Path 1420",
    d: "M582.4,303.8c-14.319,10.794-16.99,33.723-15.466,44.089-9.617,4.852-2.085,27.087-1.762,27.222a10,10,0,0,0,3.88-1.407c.244-.444-8.63-21.126.071-22.7,9.536-1.719,11.011,20.205,11.189,20.555s4.221-.28,4.465-.723-3.6-23.289-15.015-23.438c-1.131-8.587-.364-26.093,10.378-37.92C580.252,308.913,582.56,304.219,582.4,303.8Z",
    fill: "#023c74"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_525",
    "data-name": "Group 525"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1421",
    "data-name": "Path 1421",
    d: "M656.76,382.353a11.5,11.5,0,1,0,11.652-11.413A11.532,11.532,0,0,0,656.76,382.353Z",
    fill: "url(#linear-gradient-105)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1422",
    "data-name": "Path 1422",
    d: "M658.212,381.978a10.314,10.314,0,1,0,10.45-10.236A10.341,10.341,0,0,0,658.212,381.978Z",
    fill: "url(#linear-gradient-106)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1423",
    "data-name": "Path 1423",
    d: "M671.672,371.194c6.085-29.2,8.832-61.186-9.717-67.4a16.642,16.642,0,0,0,1.5,3.965c14.8,8.459,8.265,49.224,5.268,63.133-.283,1.38-1.371,3.019-1.177,4.807s2.53,2.463,3.426.99S671.437,372.25,671.672,371.194Z",
    fill: "#023c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1424",
    "data-name": "Path 1424",
    d: "M663.2,381.809a6.562,6.562,0,1,0,6.085-7.067A6.6,6.6,0,0,0,663.2,381.809Z",
    fill: "url(#linear-gradient-107)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1425",
    "data-name": "Path 1425",
    d: "M664.64,381.167a5.6,5.6,0,1,0,5.2-5.9A5.579,5.579,0,0,0,664.64,381.167Z",
    fill: "url(#linear-gradient-108)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1426",
    "data-name": "Path 1426",
    d: "M654.976,294.373s7.658,2.387,9.707,7.746c4.582,11.984,15.581,28.936,16.612,29.361,0,0-11.571,3.784-18.129,1.56,0,0,12.722,10.075,15.363,12.733,0,0-20.3,23.8-27.592,32.126s-16.17,37.955-17.085,46.017a313.137,313.137,0,0,1,2.906-36.542c2.659-17.834,7.738-29.846,13.856-51.678C654.618,321.4,661.792,298.6,654.976,294.373Z",
    fill: "url(#linear-gradient-109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1427",
    "data-name": "Path 1427",
    d: "M594.208,294.356s-9.026,2.372-11.173,7.693c-4.8,11.9-16.069,28.646-17.106,29.052,0,0,11.5,3.995,18.1,1.891,0,0-12.9,9.841-15.593,12.45,0,0,17.558,22.239,24.7,30.7s17.773,40.174,18.542,48.252a313.339,313.339,0,0,0-2.238-36.589c-2.333-17.88-7.191-29.982-12.909-51.922C592.785,321.516,587.316,298.455,594.208,294.356Z",
    fill: "url(#linear-gradient-110)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M600.583,415.547s-13.791-9.852-17.48-15.256-10.935-12.857-12.63-15.3-15.527-14.3-16.785-12.875,2.709,6.832,7.084,10.121c1.417,2.861,9.235,10.585,9.235,10.585s-8.8-5.38-10.961-6.842c-1.47-1-7.7.208-9.724.421s-8.157,5.872-7.132,7.431c.976,1.483,3.123.073,8.363-2.807a8.967,8.967,0,0,0,5.952.028c1.36,2.816,5.746,5.65,5.746,5.65s-8.416-1.84-11.5-.685-10.011,8.013-9.722,8.487c1.588,2.608,8.091-.727,11.8-4.016l10.41,4.8s-9.17-.382-11.211.164-7.964,6.968-9.646,8.859c1.191,2.365,2.522,1.458,10.759-4.843,0,0,6.694,2.509,10.965,3.728,0,0,9.889,13.054,19.276,13.191,6.775.1,14.692,3.021,14.692,3.021Z",
    fill: "url(#linear-gradient-111)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M585.294,426.484a54.894,54.894,0,0,1,16.254,1.659c8.84,2.257,37.709,11.042,37.709,11.042s-3.26,4.476-5.176,3.866c-7.076-2.257-12.931-3.566-22.98-8.2C600.171,429.808,588.29,426.827,585.294,426.484Z",
    fill: "url(#linear-gradient-112)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M640.127,417.263s-27.47-.821-42.63-4.376c-2-.469-15.062-14.1-20.389-20.015-3.265-3.623-14.036,14.788-1.945,19.224s19.021,4.575,26.029,5.719c8.672,1.415,38.182,5.785,38.182,5.785Z",
    fill: "url(#linear-gradient-113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M573.011,394.256l-3-1.434s-7.715-7.331-9.235-10.585c0,0-7-4.635-7.323-9.436a44.072,44.072,0,0,0,7.873,8.823C565.9,385.372,573.011,394.256,573.011,394.256Z",
    fill: "url(#linear-gradient-114)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M568.377,398.388s-10.308-7.707-10.679-8.241-7.074-.16-7.433-.109-5.512,3.935-8.075,3.794c0,0,.463,1.074,2.6.515a16.794,16.794,0,0,0,5.631-3.006,12.846,12.846,0,0,0,6.115.005s1.237,2.967,5.688,5.34Z",
    fill: "url(#linear-gradient-115)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M568.23,405.487l-4.99-.2s-7.543-2.473-10.41-4.8c0,0-7.4,6.354-10.931,4.748,0,0,3.634-.568,10.879-5.867C552.778,399.37,565.068,404.289,568.23,405.487Z",
    fill: "url(#linear-gradient-116)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M566.167,411.843s-12.459-3.428-13.14-3.55-5.489,5.505-9.51,7.181c0,0,1.831.9,9.307-5.535,0,0,7.331,3.2,11.283,3.26,0,0,10,15.2,21.331,13.287C585.438,426.486,573.793,426.614,566.167,411.843Z",
    fill: "url(#linear-gradient-117)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1435",
    "data-name": "Path 1435",
    d: "M558.057,374.048c.242.236-.127,1.7-1.952.5s-2.194-1.773-2.29-2.028.083-1.978,1.05-1.278A31.552,31.552,0,0,1,558.057,374.048Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M544.425,389.352c.267-.207,1.666.359.23,2s-2.058,1.93-2.323,1.99-1.948-.353-1.123-1.215A31.709,31.709,0,0,1,544.425,389.352Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1437",
    "data-name": "Path 1437",
    d: "M543.716,401.135c.267-.207,1.666.359.23,2s-2.058,1.93-2.323,1.99-1.948-.353-1.122-1.215A31.6,31.6,0,0,1,543.716,401.135Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1438",
    "data-name": "Path 1438",
    d: "M544.965,411.6c.238-.185,1.486.32.2,1.786s-1.835,1.722-2.072,1.775-1.737-.314-1-1.084A28.228,28.228,0,0,1,544.965,411.6Z",
    fill: "#ffdebd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M605.625,432.513l1.956-17.829,6.089.747-2.33,19.47Z",
    fill: "url(#linear-gradient-118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1440",
    "data-name": "Path 1440",
    d: "M681.282,362.833s-.119-21.4.517-22.337,8.179-26.686,16.851-23.343c5.018,1.935,6.275,7.186,8.327,23.889.5,4.074,2.192,39.7,1.8,44.084-.7,7.865,6.957,65.539-2.194,67.974-13.567,3.609-95.59-11.575-99.041-12.552l2.776-28.3s61.223,4.876,66.572,4.925S681.282,362.833,681.282,362.833Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M693.264,414.312a60.171,60.171,0,0,0-14.52-1.636c6.714-3.279,6.906-6.118,6.906-6.118l-4.684.959c8.914-6.933,7.122-11.961,7.122-11.961a5.693,5.693,0,0,0,2.394-5.994l-5.363,1.791c2.2-2.987.363-6.762.363-6.762L666.7,415.071l10.771.265c5.258.383,9.295,3.209,11.235,4.447,2.658,1.694,6.539,7.555,5.33,1.718a8.962,8.962,0,0,0-3.92-6.027C693.929,415.393,696.133,415.084,693.264,414.312Z",
    fill: "url(#linear-gradient-119)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_528",
    "data-name": "Group 528"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1442",
    "data-name": "Path 1442",
    d: "M684.147,383.888c-1.06-.038-4.066,5.528-8.821,9.977-.922.863-4.672,10.186-6.057,14.532l7.882-9.179S689.853,384.091,684.147,383.888Z",
    fill: "url(#linear-gradient-120)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M680.71,394.881s5.938-7.79,4.772-10.29a48.316,48.316,0,0,1-9.5,13.786Z",
    fill: "url(#linear-gradient-121)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1444",
    "data-name": "Path 1444",
    d: "M665.574,414.21c2.492-4.4,7.675-13.647,9.7-15.376,5.09-4.362,14.132-12.355,15.093-11.01,2.665,3.73-11.652,12.912-13.383,14.752-1.217,1.293-5.193,7.9-7.608,11.919C668.2,414.382,666.726,414.323,665.574,414.21Z",
    fill: "url(#linear-gradient-122)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1445",
    "data-name": "Path 1445",
    d: "M690.616,388.34s1.317,2.787-6.712,9l-3.358,1.9S687.859,393.355,690.616,388.34Z",
    fill: "url(#linear-gradient-123)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M664.72,414.366c2.245-2.253,9.128-10.394,10.007-11.01,8.631-6.039,13.565-10.278,14.207-8.919.782,1.657.592,3.58-11.762,12.79-3.362,3.49-3.3,5.168-5.479,7.345C669.325,414.466,667,414.557,664.72,414.366Z",
    fill: "url(#linear-gradient-124)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1447",
    "data-name": "Path 1447",
    d: "M689.171,395.135s.561,1.66-2.722,4.711c-3.419,3.179-9.277,7.381-9.277,7.381l-1.729,2.357-3.031,1.832,4.4-5.591S688.157,398.462,689.171,395.135Z",
    fill: "url(#linear-gradient-125)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M677.136,412.66c1.354-.991,10.52-4.945,9.047-7.639-.6-1.092-11.751,2.9-17.564,9.536l6.182.224A9.6,9.6,0,0,1,677.136,412.66Z",
    fill: "url(#linear-gradient-126)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M681.41,387.18c-.139.246.5,1.337,1.687-.051s1.351-1.937,1.369-2.164-.528-1.571-1.142-.783A26.476,26.476,0,0,0,681.41,387.18Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1450",
    "data-name": "Path 1450",
    d: "M686.265,389.9c-.208.192.066,1.425,1.622.467s1.879-1.431,1.965-1.642-.021-1.657-.848-1.095A26.482,26.482,0,0,0,686.265,389.9Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M684.935,396.215c-.222.176-.042,1.426,1.582.588s1.981-1.286,2.083-1.49.1-1.654-.763-1.155A26.465,26.465,0,0,0,684.935,396.215Z",
    fill: "#ffdebd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M682.413,405.737c-.22.122.013,1.5,1.645,1.082s1.979-.79,2.075-.977.041-1.725-.827-1.447A17.647,17.647,0,0,0,682.413,405.737Z",
    fill: "#ffdebd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1453",
    "data-name": "Path 1453",
    d: "M703.5,322.4c1.588,4.707,5.6,21.475,3.718,53.365-1.181,20.079-10.552,21.451-11.531,18.771S698.3,306.983,703.5,322.4Z",
    fill: "url(#linear-gradient-127)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M610.366,411.222s58.682,2.2,69.357,3.967-3.753,14.889-14.272,14.292-56.045-7.644-56.045-7.644Z",
    fill: "url(#linear-gradient-128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M710.278,410.945s.844,10.639,1.079,19.221c.309,11.152.25,20.022-3.827,22.786-6.215,4.214-40.381-2.778-65.217-6.153,0,0,41.114,2,50.16-.925S709.518,421.043,710.278,410.945Z",
    fill: "url(#linear-gradient-129)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1456",
    "data-name": "Path 1456",
    d: "M542.258,420.729s-1.83,33.7,4.488,36.769,26.976,4.245,38.009,3.636c0,0-16.6-6.113-26.247-11.213S542.176,429.748,542.258,420.729Z",
    fill: "url(#linear-gradient-130)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_549",
    "data-name": "Group 549"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 123.453,
    cy: 13.805,
    rx: 123.453,
    ry: 13.805,
    transform: "translate(290.181 955.976)",
    fill: "url(#radial-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1457",
    "data-name": "Path 1457",
    d: "M387.3,461.91l-1.958,46.344,53.133,1.306L430.9,464.52Z",
    fill: "url(#linear-gradient-131)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1458",
    "data-name": "Path 1458",
    d: "M423.72,491.674l1.5,13.381,7.9.327-.783-15.274Z",
    fill: "#b8cff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1459",
    "data-name": "Path 1459",
    d: "M388.08,485.8l-3.133,22.324,7.572.848,1.827-22.584Z",
    fill: "#b8cff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1460",
    "data-name": "Path 1460",
    d: "M386.9,503.423s33.29.783,45.039-2.742l1.175,4.7a120.732,120.732,0,0,1-47,2.35Z",
    fill: "#b8cff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1461",
    "data-name": "Path 1461",
    d: "M410.4,595.459l-13.12,65.208,32.7-.2Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_532",
    "data-name": "Group 532"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_530",
    "data-name": "Group 530"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1462",
    "data-name": "Path 1462",
    d: "M319.206,929.365s.426,7.372-.854,10.865c-1.891,5.158-18.025,23.309-18.392,27.977-.631,8.054,2.932,7.3,2.932,7.3s15.119,2.4,27.226,1.717c8.123-.46,14.46-3.537,15.106-4.506a88.883,88.883,0,0,0,4.37-7.854l10.82-1.6s.151-12.14-1.26-12.816l-3.12-16.5S321.974,927.565,319.206,929.365Z",
    fill: "url(#linear-gradient-133)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1463",
    "data-name": "Path 1463",
    d: "M349.57,964.869s.293-9.847,4.839-12.09c2.871-1.417,3.605-1.712,4.72-2.384,1.554.84,1.323,12.9,1.323,12.9S357.764,963.752,349.57,964.869Z",
    fill: "url(#linear-gradient-134)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1464",
    "data-name": "Path 1464",
    d: "M301.2,974.874s34.543,4.927,44.047-2.18c0,0-3.089,5.619-20.609,6.081C305.219,979.286,301.2,974.874,301.2,974.874Z",
    fill: "url(#linear-gradient-135)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1465",
    "data-name": "Path 1465",
    d: "M311.052,966.312s17.605.53,27.434-4.487,7.7,11.85-6.216,11.737S294.481,965.227,311.052,966.312Z",
    fill: "url(#linear-gradient-136)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_531",
    "data-name": "Group 531"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1466",
    "data-name": "Path 1466",
    d: "M501.47,929.365s-.427,7.372.854,10.865c1.891,5.158,18.025,23.309,18.392,27.977.631,8.054-2.932,7.3-2.932,7.3s-15.118,2.4-27.225,1.717c-8.123-.46-14.46-3.537-15.106-4.506a88.836,88.836,0,0,1-4.372-7.854l-10.819-1.6s-.151-12.14,1.262-12.816l3.119-16.5S498.7,927.565,501.47,929.365Z",
    fill: "url(#linear-gradient-137)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M471.105,964.869s-.292-9.847-4.838-12.09c-2.87-1.417-3.605-1.712-4.718-2.384-1.555.84-1.325,12.9-1.325,12.9S462.914,963.752,471.105,964.869Z",
    fill: "url(#linear-gradient-138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M519.48,974.874s-34.541,4.927-44.046-2.18c0,0,3.088,5.619,20.607,6.081C515.457,979.286,519.48,974.874,519.48,974.874Z",
    fill: "url(#linear-gradient-139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M509.624,966.312s-17.6.53-27.434-4.487-7.7,11.85,6.216,11.737S526.2,965.227,509.624,966.312Z",
    fill: "url(#linear-gradient-140)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1470",
    "data-name": "Path 1470",
    d: "M325.97,576.95l-3.149,208.891-1.836,108.906L315.527,910.1l3.53,25.586a134.678,134.678,0,0,1,21.478.886c-9.166-2.273-15.182-3.776-15.182-3.776s8.159-49.135,12.358-69.079,5.055-134.913,5.055-139.113,23.443-166.9,32.891-205.742a79.512,79.512,0,0,1,4.362-13.247c-14.108-.569-28.19-2.043-42.416-3.825Z",
    fill: "url(#linear-gradient-141)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1471",
    "data-name": "Path 1471",
    d: "M496.022,821.531,494.974,742.8l-1.051-169L473.515,501.52c-16.692,1.367-32.935,2.339-49.664,3.339l27.034,76.289s15.046,129.815,15.046,141.36,5.344,105.589,6.394,113.986,12.52,97.557,12.52,97.557-10.155,5.311-22.493,11.068l.08.276s17.846-6.3,23.094-8.4,16.713,2.179,16.713,2.179l2.182-22.124-1.05-25.193Z",
    fill: "url(#linear-gradient-142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    d: "M376.331,503.423c-1.869,3.591-2.553,9.852-3.742,14.743C363.142,557.005,341.1,719.709,341.1,723.908s-3.149,115.467-7.347,135.411-8.771,76.292-8.771,76.292,7.52.373,17.437,1.213a115.033,115.033,0,0,1,14.767,2.4,149.4,149.4,0,0,1,7.627-15.868c4.2-7.347,4.2-20.994,4.2-20.994l5.249-31.49,5.249-108.12s14.737-80.828,16.836-83.977,15.7-69.7,15.7-69.7C426.742,657.354,436.19,738.6,436.19,738.6l7.347,92.375,11.548,48.286-2.1,24.144-1.049,11.545,5.248,12.6,5.267,17.928c12.73-4.369,23.55-8.646,23.55-8.646s-4.243-93.259-5.292-101.657-13.646-101.822-13.646-113.369-9.447-142.759-9.447-142.759l-24.5-75.625C430.566,503.57,403.354,508.123,376.331,503.423Z",
    fill: "url(#linear-gradient-143)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    d: "M379.506,762.747s18.544-87.825,19.593-89.574,12.946-61.583,12.946-61.583,17.229,81.374,17.929,88.021,7.143,47.224,9.525,80.518c0,0,.889-88.411.189-92.26s-26.942-96.224-26.942-96.224-11.9,25.193-13.3,32.891S379.506,762.747,379.506,762.747Z",
    fill: "url(#linear-gradient-144)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1474",
    "data-name": "Path 1474",
    d: "M450.652,504.325c-11.417,1.03-23.939,1.781-33.2,2.577-19.758,1.7-60.2-4.762-60.2-4.762l-1.406,13.168s4.442,5.438,48.648,7.528c15.138.716,34.215-1.474,49.931-3.937C452.9,513.4,450.591,504.992,450.652,504.325Z",
    fill: "url(#linear-gradient-145)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1475",
    "data-name": "Path 1475",
    d: "M418.123,519.844a8.737,8.737,0,0,1,.061,2.266c-.169.68-17.271,1.487-18.661-.929s-1.157-12.188.037-13.675,18.4-1.886,18.624-.821a16.331,16.331,0,0,1,0,2.242s-14.63-.127-15.621.557-.615,3.3-.615,3.3a40.7,40.7,0,0,1,5.516.775c.59.338.105,1.773.005,2.378s-5.575.732-5.575.732-.4,2.57.47,3.2S418.123,519.844,418.123,519.844Z",
    fill: "url(#linear-gradient-146)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1476",
    "data-name": "Path 1476",
    d: "M417.633,519.746a8.738,8.738,0,0,1,.061,2.266c-.169.68-17.27,1.487-18.66-.928s-1.157-12.189.036-13.676,18.4-1.886,18.624-.821a16.169,16.169,0,0,1,0,2.242s-14.63-.126-15.62.557-.615,4.085-.615,4.085l5.516-.007,0,2.377-5.575-.051s-.4,3.353.471,3.98S417.633,519.746,417.633,519.746Z",
    fill: "url(#linear-gradient-147)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1477",
    "data-name": "Path 1477",
    d: "M398.655,462.692H424.5l2.742,28.982-13.708,20.366-17.624-18.016Z",
    fill: "#3182ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1478",
    "data-name": "Path 1478",
    d: "M425.139,504.353l14.769,155.858h18.538L435.738,503.019Z",
    fill: "url(#linear-gradient-148)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1479",
    "data-name": "Path 1479",
    d: "M384.947,504.6l7.8.673L379.073,659.95l-16.972-.783Z",
    fill: "url(#linear-gradient-149)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1480",
    "data-name": "Path 1480",
    d: "M424.43,495.835l4.381-6.119-3.525-32.506-27.219,4.406-2.154,32.408,7.6,7.769,10.415-18.735Z",
    fill: "url(#linear-gradient-150)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1481",
    "data-name": "Path 1481",
    d: "M422.936,467.783l64.97-1.566s23.8,152.218,29.384,182.054c-30.124,15.334-73.2,15.334-73.2,15.334Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1482",
    "data-name": "Path 1482",
    d: "M393.955,470.133l-67.9-2.351s-21.135,157.964-24.323,181.441c26.426,12.816,74.206,14.382,74.206,14.382Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1483",
    "data-name": "Path 1483",
    d: "M368.89,317s22.915-20.979,26.7-21.736,22.436-.755,23.191-.252,18.907,21.68,18.907,21.68l2.092,113.884-59.53-1.175Z",
    fill: "#d4e1f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1484",
    "data-name": "Path 1484",
    d: "M427.375,307.993l-17.754,57.7,15.207-11.441,12.856-37.561Z",
    fill: "url(#linear-gradient-151)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1485",
    "data-name": "Path 1485",
    d: "M375.678,315.043l7.05-5.483L399.7,373.789l-7.833,13.055Z",
    fill: "url(#linear-gradient-152)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1486",
    "data-name": "Path 1486",
    d: "M377.767,321.048l-4.177-6.005s20.611-19.4,23.005-20.407,17.268-.757,17.268-.757,14.622,12.1,23.822,22.814l-2.016,5.925s-20.3-18.5-22.915-20.891c-.821-.751-13.614.4-14.621.783S377.767,321.048,377.767,321.048Z",
    fill: "url(#linear-gradient-153)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_533",
    "data-name": "Group 533"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1487",
    "data-name": "Path 1487",
    d: "M395.8,298.491s4.424-5.332,8.587-4.754c3.416.474,10,2.878,10.215,3.729s-1.522,13.558-2.967,15.849-8.849,2.3-11.3.682S395.8,298.491,395.8,298.491Z",
    fill: "#3182ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1488",
    "data-name": "Path 1488",
    d: "M396.444,302.226l-.932-4.927s4.272-3.176,8.954-3.558C404.466,293.741,397.212,300.074,396.444,302.226Z",
    fill: "url(#linear-gradient-154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    "data-name": "Path 1489",
    d: "M390.4,428.118l2.86-70.021s4.743-27.548,5.841-35.323,3.016-11.222,3.016-11.222l8.838-.117s1.146,8.378,1.365,9.145,8.562,23.337,8.876,33.444-4.517,70.805-4.517,70.805Z",
    fill: "#3182ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    "data-name": "Path 1490",
    d: "M400.33,314s8.679,1.559,11.3-.682l5.418,21.562-7.991-14.693s-11.292,12.4-11.906,14.9Z",
    fill: "url(#linear-gradient-155)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1491",
    "data-name": "Path 1491",
    d: "M414.255,301.4l.739-4.809a54.868,54.868,0,0,0-10.528-2.851S411.591,296.908,414.255,301.4Z",
    fill: "url(#linear-gradient-156)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1492",
    "data-name": "Path 1492",
    d: "M413.321,307.194s-.424,5.021-1.943,6.594c-1.9,1.968-4.923,1.971-6.075,1.878-1.029-.083-4.2-.121-5.616-2.37a15.268,15.268,0,0,1-1.864-4.94s2.873,4.985,6.881,5.665S411.684,309.983,413.321,307.194Z",
    fill: "url(#linear-gradient-157)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1493",
    "data-name": "Path 1493",
    d: "M388.647,429.839s.62-53,5.5-76.844c1.077,8.714,4.055,39.23,8.6,53.607a15.9,15.9,0,0,0,7.05-.522s-.869-39.524,8.269-67.722c1.828,6,4.263,13.936,4.263,13.936l-1.044,72.324-12.271.521Z",
    fill: "url(#linear-gradient-158)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1494",
    "data-name": "Path 1494",
    d: "M363.785,285.732s-1.769-14.1,20.462-17.641,54.563-4.042,58.6,11.62S363.785,285.732,363.785,285.732Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1495",
    "data-name": "Path 1495",
    d: "M372.963,274.238c-7.176,3.729-1.421-1.55-3.283-.99,0,0,13.355-8.695,34.608-8.525,21.048.168,32.657,5.655,35.869,9.936-.45-.6-.306,2.632-1.284,1.369-.876-1.132-4.379-3.139-6.8-4.065-7.111-2.717-18.177-4.065-26.609-3.705C390.974,268.881,385.931,267.5,372.963,274.238Z",
    fill: "url(#linear-gradient-159)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1496",
    "data-name": "Path 1496",
    d: "M395.717,457.851l-68.929,3.03-1.958,16.253s29.394,4,36.453,6.686c4.122,1.57,21.314,8.38,30.322,11.513Z",
    fill: "url(#linear-gradient-160)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1497",
    "data-name": "Path 1497",
    d: "M439.7,285.77s51.09,15.461,59.156,17.479c0,0-14.687,58.806-18.488,76.634a293.711,293.711,0,0,0-5.376,41.007l-59.89,5.771-.522-32.507Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1498",
    "data-name": "Path 1498",
    d: "M310.3,307.282s52.434-19.159,57.811-21.847l25.4,108.181,1.272,12.441,1.127,21-57.045-4.485s-4.2-38.653-5.547-42.35S311.642,309.971,310.3,307.282Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1499",
    "data-name": "Path 1499",
    d: "M440.059,285.812l59.712,17.552S466.611,303.627,440.059,285.812Z",
    fill: "url(#linear-gradient-161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1500",
    "data-name": "Path 1500",
    d: "M310.3,307.282l60.648-23.7S341.41,307.792,310.3,307.282Z",
    fill: "url(#linear-gradient-162)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_534",
    "data-name": "Group 534"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1501",
    "data-name": "Path 1501",
    d: "M407.834,293.282c7.148-1.5,15.811-9.53,21.721-16.672,0,0-.767-18.8-1.009-21.006,0,0-17.971,12.688-51.454,1.032,0,0,.388,11.85.568,21.458C385.252,289.078,395.918,295.783,407.834,293.282Z",
    fill: "url(#linear-gradient-163)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1502",
    "data-name": "Path 1502",
    d: "M377.43,268.292s0,4.176.932,6.218c.75,1.647,2.856,8.234,9.579,12.1s14.212,7.058,16.518,7.144,13.059-3.279,14.908-4.623,9.411-8.234,9.579-10.923a65.517,65.517,0,0,0,.154-12.082s-2.7,11.427-8.388,15.443c-5.714,4.033-13.278,7.731-15.463,8.067s-16.133-6.217-18.99-8.4S378.944,271.485,377.43,268.292Z",
    fill: "url(#linear-gradient-164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1503",
    "data-name": "Path 1503",
    d: "M438.842,399.875c-8.962,4.136-15.541,5.574-24.081,5.233.033,2.317-.083,18.55-.18,20.541l26.278,1.788L469.092,399.2l3.025-24.872S448.023,395.639,438.842,399.875Z",
    fill: "url(#linear-gradient-165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1504",
    "data-name": "Path 1504",
    d: "M394.775,405.965c-12.283-.492-58.113-22.224-58.113-22.224l4.033,28.906,55.218,7.748C396.5,418.68,394.909,408.853,394.775,405.965Z",
    fill: "url(#linear-gradient-166)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1505",
    "data-name": "Path 1505",
    d: "M486.334,453.684l-65.486,1.829c.653,4.96,2.284,13.3,2.823,18.977l8.541-5.115s41.3,5.066,56.765,3.72Z",
    fill: "url(#linear-gradient-167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1506",
    "data-name": "Path 1506",
    d: "M456.319,409.621A382.126,382.126,0,0,0,474.47,358.2c7.712-28.743,19.077-54.523,25.229-54.611l-19.18,88.9Z",
    fill: "url(#linear-gradient-168)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1507",
    "data-name": "Path 1507",
    d: "M519.841,413.923c.662-11.75-8.708-48.3-8.978-53.051s-5.834-56.5-11.164-57.287-17.4,41.745-17.835,43.184c-1.835,6.064-9.465,45.911-9.465,45.911l3.753,25.753c7.65.722,16.169,0,20.976,6.882,8.044,10.877,12.247,24.383,13.366,37.936.325-.048.588-.093.773-.134C514.7,462.4,519.178,425.673,519.841,413.923Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1508",
    "data-name": "Path 1508",
    d: "M480.52,352.383l-10.337,49,16.133,17.647s17.04,6.144,21.681,6.806c8.822,1.261-4.79-16.384-4.79-16.384s8.823-9.329,0-11.85c0,0,1.766-10.586-10.082-7.814,0,0,6.3-7.563-1.009-8.823S479.354,358.874,480.52,352.383Z",
    fill: "url(#linear-gradient-169)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_535",
    "data-name": "Group 535"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1509",
    "data-name": "Path 1509",
    d: "M408.421,468.617s29.172-9.83,36.059-13.461,33.27-30.226,34.891-31.438,15.887-10.285,16.824-11.384,1.642-5.427-1.736-5.378c0,0,5.878-1.194,7.235-1.66,2.017-.694,6.429-6.286-3.689-6.3,0,0,4.582-1.809,3-4.979s-9.978-2.193-12.547-1.737-15.484,3.574-15.484,3.574,14.606-5.933,16.428-8.723c1.484-2.268.233-4.7-3.661-4.527s-13.7,4.4-14.929,4.969-8.608,6.015-9.5,6.612-25.884,28.663-25.884,28.663l-26.886,34.48Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1510",
    "data-name": "Path 1510",
    d: "M436.909,420.546l6.8-6.981s8.825,2.7,31.261,1.939c5.038-.17,12.6,0,13.613-.253s8.252-3.144,8.088-7.043a3.769,3.769,0,0,1-.48,4.126c-2.175,2.78-11.894,7.96-11.894,7.96Z",
    fill: "url(#linear-gradient-170)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1511",
    "data-name": "Path 1511",
    d: "M482.567,383.28s-1.3,3.652,2.335,3.449c2.056-.113.424.071,2.7-.464s1.572-4.173-.178-4.157A9.666,9.666,0,0,0,482.567,383.28Z",
    fill: "#f7dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1512",
    "data-name": "Path 1512",
    d: "M493.5,392.263s-2.219,3.428,1.571,4.1c2.146.384.422.179,2.892.18s2.624-3.895.82-4.307A10.256,10.256,0,0,0,493.5,392.263Z",
    fill: "#f7dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M490.417,408.823s-.462,3.051,2.51,2.306c1.682-.42.362-.012,2.151-.8s.6-3.5-.843-3.206A8.4,8.4,0,0,0,490.417,408.823Z",
    fill: "#f7dcbb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M458.431,404.284s13.964-8.288,18.09-9.64a50.24,50.24,0,0,0,9.464-4.862s3.444-1.8,3.862-3.016a3.292,3.292,0,0,0,.069-2.112s.207.636-1.087,1.733-8.237,4.484-9.513,5.456-5.3,1.573-6.525,2.17S458.431,404.284,458.431,404.284Z",
    fill: "url(#linear-gradient-171)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M501.157,396.247s-1.009,2.3-2.352,2.606c-1.374.309-6.768,1.08-8.334,1.378s-10.4,1.648-10.807,1.847-13.692,9.088-13.692,9.088,10.461-9.651,12.22-10.432S498.981,398.241,501.157,396.247Z",
    fill: "url(#linear-gradient-172)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M504.277,402.535a5.109,5.109,0,0,1-2.959,3.074,87.324,87.324,0,0,1-9.236,1.741c-.783.148-10.247,4.374-11.563,4.7s-10.755,6.307-10.755,6.307,7.774-6.837,10.1-8.049a100.042,100.042,0,0,1,10.944-4.753C492.926,404.956,500.34,405.31,504.277,402.535Z",
    fill: "url(#linear-gradient-173)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M461.4,402.55s11.4-6.658,12.817-7.045c5.541-1.517,12.12-2.785,12.12-2.785s-8.256,2.7-11.281,4.129S461.4,402.55,461.4,402.55Z",
    fill: "url(#linear-gradient-174)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M445.619,411.437s13.9-15.847,15.154-17.023,8.6-6,9.914-6.885,9.587-3.639,9.587-3.639-7.484,3.633-9,4.389-8.823,6.386-9.748,7.144S445.619,411.437,445.619,411.437Z",
    fill: "url(#linear-gradient-175)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M496.753,399.434s-1.745,3.644,1.986,3.825c2.114.1.426.121,2.808-.192s2.083-4.155.3-4.328A9.856,9.856,0,0,0,496.753,399.434Z",
    fill: "#f7dcbb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M405.9,470.459l26.721-9.578-27.9-4.875Z",
    fill: "#efc399"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M351.787,411.3s-16.132-45.712-23.191-71.256c-1.244-4.5-8.868-33.4-17.2-33.2l25.935,105.465Z",
    fill: "url(#linear-gradient-176)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M403.38,472.644l12.941-.5,1.85-15.63-12.774.841Z",
    fill: "url(#linear-gradient-177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M312.252,306.824c3.454.882,9.636,15.583,13,29.532,2.743,11.368,8.719,49.4,10.4,57.805,2.016,10.085,3.718,26.895,3.718,26.895l78.084,24.8s-7.419,27.705-9.352,32.6-5.3,14.727-5.3,14.727-44.187-15.9-53.1-18.182-48.889-8.208-48.889-8.208-11.291-1.942-8.35-54.314c.894-15.929,5.176-36.73,5.545-48.906,1.009-33.275,4.98-46.4,5.923-48.9C305.571,310.327,309.281,306.065,312.252,306.824Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M330.313,363.227s9.291,30.345,9.543,32.11.252,13.36.252,13.36L333.05,421.3l16.637,11.343,22.435,2.773,44.87,13.241-4.6,15.63-11.028-1.9s-2.017-5.545-3.025-9.58c-8.319-3.025-31.259-9.578-34.789-9.831s-18.4-4.284-28.484-11.848c-2.437-1.827-25.769,4.154-23.192.5C317.925,423.067,336.7,412.635,330.313,363.227Z",
    fill: "url(#linear-gradient-178)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M397.961,443.612l1.052,6.177s5.546.5,6.386-3.362l.839-3.865h0Z",
    fill: "#b8cff4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M408.1,448.6s-34.023-10.485-36.241-11.181-5.4,1.058-7.161.91-15.9-3.379-16.866-3.966S331.107,422.819,330.417,422s4.466-18.593,12.5-17.91c6.548.557,19.064,6.682,20.989,7.859s23.017,6.007,25.3,5.948,17.875,1.016,17.875,1.016Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M354.228,407.4s7.514,3.133,9.681,4.554c3.917,1.567,22.582,5.821,23.339,5.821s11.974.632,11.974.632l.126,2.394s-10.84,0-12.1-.252-22.689-6.3-23.444-6.555S354.228,407.4,354.228,407.4Z",
    fill: "url(#linear-gradient-179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M329.52,422.562s2.8-10.384,5.547-14.116c3.527-4.789,7.1-4.972,11.136-3.76,0,0-4.331.987-6.851,3s-4.285,2.773-4.285,4.287-1.513,2.015-1.766,4.032,1.26,3.53,4.033,6.3,10.084,9.327,12.6,9.578,13.552,1.688,19.662,2.271c5.295.5,32.269,3.781,32.269,3.781l-1.032,8.641s-27.687-8.68-29.19-8.92-6.552,1.422-7.089,1.288c-1.3-.331-15.84-3.944-17.393-4.538C346.055,433.984,329.52,422.562,329.52,422.562Z",
    fill: "url(#linear-gradient-180)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M394.872,418.137l4.35.267s6.3,23.949,3.907,28.61l-4.915-1.386S401.3,435.782,394.872,418.137Z",
    fill: "url(#linear-gradient-181)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M402.709,448.444l2.555,11.4s4.5-10.22,4.336-12.237Z",
    fill: "#dbd8d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M396.972,418.241l5.737.121L415.482,451.3l-16.469-1.512a14.933,14.933,0,0,0,2.184-8.237C401.2,436.343,398.483,421.6,396.972,418.241Z",
    fill: "url(#linear-gradient-182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M476.231,418.983l-74.5-.609c.948.755,7.531,33.936,3.556,41.457,14.393,1.553,29.4,3.23,35.443,3.692,37.4,2.865,64.073.594,69.762-.272a64.048,64.048,0,0,0-12.328-39.176C493.358,417.193,476.231,418.983,476.231,418.983Z",
    fill: "#f1f0f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M510.519,362.063c.5,24.956-.688,29.532-8.572,15.125-7.311-13.361-21.3-54.606-3.089-73.939C507.494,300.806,510.519,362.063,510.519,362.063Z",
    fill: "url(#linear-gradient-183)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M310.3,307.282c1.751-.547,9.224,6.211,11.24,24.363s-6.386,63.188-13.108,65.877S299.876,374.189,298.2,366.8s2.652-41.3,4.034-47.2C303.572,313.864,305.446,308.8,310.3,307.282Z",
    fill: "url(#linear-gradient-184)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M292.155,437.222s.548,28.738,9.087,29.882,22.772,3.614,22.772,3.614l22.236,3.514S309.1,463.9,305.32,462.141,292.43,444.138,292.155,437.222Z",
    fill: "url(#linear-gradient-185)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M517.472,436.472s-2.164,26.65-6.137,27c-59.113,5.167-106.059-3.642-106.059-3.642a18.4,18.4,0,0,0,1.26-6.743c63.527,6.554,93.412,2.955,98.855.232C513.816,449.106,517.472,436.472,517.472,436.472Z",
    fill: "url(#linear-gradient-186)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M404.44,293.754s21.145-8.824,23.413-17.395c1.8-6.8,1.3-9.689,1.3-9.689s1.3.559,2.985,6.16a133.265,133.265,0,0,0,5.229,14.2l-6.49,28.4s-14.558-16.7-16.385-17.773A27.689,27.689,0,0,0,404.44,293.754Z",
    fill: "url(#linear-gradient-187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M404.459,293.754s-22.668-10.666-24.707-17.395c-1.8-5.956-2.306-7.452-2.306-7.452s-1.787,1.712-3.577,7.279c-3.8,11.833-2.238,20.449-2.238,20.449l4.7,21.149s18.043-17.477,20.564-20.25S404.459,293.754,404.459,293.754Z",
    fill: "url(#linear-gradient-188)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M404.459,293.754a125.636,125.636,0,0,0,15.264-8.74c3.164-2.235,7.142-5.293,8.962-12.679a17.126,17.126,0,0,0,.47-5.674s4.348,3.248.611,11.037C426.186,285.158,417.466,291.828,404.459,293.754Z",
    fill: "url(#linear-gradient-189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M377.446,268.907s2.661,8.044,3.2,8.9c3.073,4.894,14.626,11.364,23.815,15.945,0,0-7.631-.428-19.564-9.082-2.556-1.855-6.386-4.2-6.89-8.067A76.111,76.111,0,0,1,377.446,268.907Z",
    fill: "#e4ecfb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M401.635,418.325s83.1.494,84.681.708c18.657,2.521,25.714,13.361,7.061,16.89-20.986,3.971-87.726,0-87.726,0S403.769,424.221,401.635,418.325Z",
    fill: "url(#linear-gradient-190)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1542",
    "data-name": "Path 1542",
    d: "M418.6,361.217l28.292-72.749s11.114,19.533,14.82,20.544c0,0-13.135,2.357-17.177,2.357l14.818,11.789s-32.4,24.685-44.569,81.865Z",
    fill: "url(#linear-gradient-191)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1543",
    "data-name": "Path 1543",
    d: "M388.962,368.628,362.34,289.261s-11.368,19.387-15.087,20.347c0,0,13.1,2.532,17.144,2.585l-14.975,11.591s30.7,29.9,45.316,81.337Z",
    fill: "url(#linear-gradient-192)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1544",
    "data-name": "Path 1544",
    d: "M402.179,525.747s-1.566,41.122,1.959,45.039,10.574,5.091,10.574,5.091-6.658-3.525-8.225-7.05S402.179,525.747,402.179,525.747Z",
    fill: "url(#linear-gradient-193)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_537",
    "data-name": "Group 537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_536",
    "data-name": "Group 536"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1545",
    "data-name": "Path 1545",
    d: "M362.377,343.812s9.4,39.591-15.18,40.7c0,0-1.28,2.122,2.274,2.232s23.558-5.3,15.534-43.482Z",
    fill: "url(#linear-gradient-194)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1546",
    "data-name": "Path 1546",
    d: "M350.427,347.2s11.5,39.033,33.385,27.792c0,0,2.162,1.207-.869,3.069s-23.078,7.093-35.067-30.033Z",
    fill: "url(#linear-gradient-195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1547",
    "data-name": "Path 1547",
    d: "M381.937,375.937s2.267-2.427,3.038-2.068,1.873,3.35,1.556,3.836-2.74.752-3.684.575A9.358,9.358,0,0,1,381.937,375.937Z",
    fill: "#022d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1548",
    "data-name": "Path 1548",
    d: "M350.78,386.331s-2.831,1.735-3.48,1.179-.909-3.726-.475-4.11,2.844.009,3.707.433A9.357,9.357,0,0,1,350.78,386.331Z",
    fill: "#022d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1549",
    "data-name": "Path 1549",
    d: "M363.648,281.81c-13.683,9.725-15.8,31.551-14.34,41.457-9.189,4.636-1.992,25.884-1.683,26.011a9.583,9.583,0,0,0,3.708-1.344c.232-.425-8.248-20.186.066-21.688,9.114-1.642,10.523,19.308,10.692,19.642s4.035-.268,4.266-.691-3.436-22.254-14.346-22.4c-1.08-8.206-.348-24.933,9.915-36.235C362.033,286.026,363.8,282.213,363.648,281.81Z",
    fill: "#023c74"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_538",
    "data-name": "Group 538"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1550",
    "data-name": "Path 1550",
    d: "M438.058,355.079a10.99,10.99,0,1,0,11.134-10.906A11.021,11.021,0,0,0,438.058,355.079Z",
    fill: "url(#linear-gradient-196)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1551",
    "data-name": "Path 1551",
    d: "M439.445,354.722a9.857,9.857,0,1,0,9.988-9.781A9.885,9.885,0,0,0,439.445,354.722Z",
    fill: "url(#linear-gradient-197)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M452.31,344.416c5.813-27.9,7.034-58.562-8.626-64.2a11.793,11.793,0,0,0,.967,3.2c14.02,8.376,7.7,47.426,4.838,60.717-.27,1.319-1.309,2.885-1.123,4.593a1.812,1.812,0,0,0,3.273.947C452.492,348.261,452.085,345.426,452.31,344.416Z",
    fill: "#023c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1553",
    "data-name": "Path 1553",
    d: "M444.209,354.559a6.27,6.27,0,1,0,5.816-6.752A6.3,6.3,0,0,0,444.209,354.559Z",
    fill: "url(#linear-gradient-198)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1554",
    "data-name": "Path 1554",
    d: "M445.591,353.946a5.352,5.352,0,1,0,4.966-5.641A5.331,5.331,0,0,0,445.591,353.946Z",
    fill: "url(#linear-gradient-199)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1555",
    "data-name": "Path 1555",
    d: "M374.332,270.829s-6.651,2.315-8.827,6.793c-5.357,11.027-15.354,27.374-16.345,27.761,0,0,10.988,3.819,17.293,1.808,0,0-12.333,9.4-14.9,11.9,0,0,16.779,21.251,23.6,29.331s18.5,49.262,19.682,58.293c0,0-1.876-30.064-4.1-47.149s-6.874-28.651-12.336-49.616C374.822,296.225,367.746,274.745,374.332,270.829Z",
    fill: "url(#linear-gradient-200)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1556",
    "data-name": "Path 1556",
    d: "M434.39,270.365s7.284,2.652,9.135,7.325c4.518,11.395,14.889,27.649,15.874,28.055,0,0-11.058,3.616-17.325,1.491,0,0,12.158,9.627,14.683,12.167,0,0-19.395,22.745-26.368,30.7s-14.755,47.742-15.628,55.447a274.657,274.657,0,0,1,2.079-46.4c2.345-17.067,7.395-28.518,13.242-49.379C433.906,296.118,440.9,274.4,434.39,270.365Z",
    fill: "url(#linear-gradient-201)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1557",
    "data-name": "Path 1557",
    d: "M494.216,506.556l13.34,146.01s7.453-2.852,9.734-4.295Z",
    fill: "url(#linear-gradient-202)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1558",
    "data-name": "Path 1558",
    d: "M321.452,502.444,301.733,649.223a78.821,78.821,0,0,0,11.629,4.566Z",
    fill: "url(#linear-gradient-203)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_539",
    "data-name": "Group 539"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1559",
    "data-name": "Path 1559",
    d: "M493.177,499.712a411.014,411.014,0,0,1-49.109,5.829s5.979,69.133,9.023,70.323,48.507-5.219,50.92-7.056S493.177,499.712,493.177,499.712Z",
    fill: "url(#linear-gradient-204)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1560",
    "data-name": "Path 1560",
    d: "M444.068,505.541s27.233-.343,49.109-5.829C493.177,499.712,451.451,503.311,444.068,505.541Z",
    fill: "url(#linear-gradient-205)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_540",
    "data-name": "Group 540"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1561",
    "data-name": "Path 1561",
    d: "M321.676,500.495s27.4,5.632,49.232,4.678c0,0-4.358,69.254-7.374,70.515s-48.614-4.081-51.071-5.862S321.676,500.495,321.676,500.495Z",
    fill: "url(#linear-gradient-206)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M321.676,500.495s24.487,5.051,49.232,4.678C370.908,505.173,337.469,500.636,321.676,500.495Z",
    fill: "url(#linear-gradient-207)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_547",
    "data-name": "Group 547"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_541",
    "data-name": "Group 541"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M353.6,207.248c-5.156.952-4.022,4.465-1.768,10.612,2.189,16.341,6.395,19.6,8.181,18.608C363.276,234.647,359.84,206.1,353.6,207.248Z",
    fill: "#f0c499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M357.768,230.506s-2.41-3.06-1.447-8.8c2.272-13.545-6.033-14.9-4.44-5.492,0,0,1.3-4.332,2.308-2.968,1.245,1.677-1.469,2.433-.331,9.538C354.455,226.478,357.768,230.506,357.768,230.506Z",
    fill: "url(#linear-gradient-208)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_542",
    "data-name": "Group 542"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1565",
    "data-name": "Path 1565",
    d: "M450.7,207.126c5.2.711,4.271,4.272,2.372,10.515-1.248,16.419-5.261,19.875-7.1,18.963C442.611,234.937,444.4,206.266,450.7,207.126Z",
    fill: "#f0c499"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1566",
    "data-name": "Path 1566",
    d: "M447.871,230.546s2.234-3.167.943-8.857c-3.044-13.421,5.168-15.154,4.119-5.692,0,0-1.542-4.262-2.477-2.854-1.147,1.73,1.607,2.36.879,9.509C450.95,226.368,447.871,230.546,447.871,230.546Z",
    fill: "url(#linear-gradient-209)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1567",
    "data-name": "Path 1567",
    d: "M446.651,205.616c1.538-38.442-12.022-37.909-15.38-41.831-6.839-7.973-15.812-15.186-34.182-14.758,0,0-23.929.844-29.91,13.948-6.4,14.012-8.861,31.21-8.389,49.277.572,21.9,1.714,32.348,3.626,36.94a19.874,19.874,0,0,0,6.627,8.52c6.809,5.382,14.039,16.1,19.482,22.248,1.889,2.134,27.717,1.076,31.005-.71,5.68-3.086,12.1-13.36,19.571-20.829,3.3-3.3,5.443-8.674,5.443-11.36,0-3.077,1.835-19.354,1.721-21.644C445.654,213.035,446.226,216.3,446.651,205.616Z",
    fill: "#f7d4ab"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1568",
    "data-name": "Path 1568",
    d: "M439.826,215.913c6.022-29.071-28.962-15.184-28.962-15.184-.61,3.935-2.874,12.84-.816,14.539C425.765,228.228,439.826,215.913,439.826,215.913Z",
    fill: "url(#linear-gradient-210)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1569",
    "data-name": "Path 1569",
    d: "M433.015,197.18c-8.949-1.482-15.893-1.486-21.438.965-2.1.927-.643,4.354,1.857,4.286,4.708-.128,11.365-1.5,15.835-1.578,6.538-.109,9.208,1.133,9.208,1.133A7.229,7.229,0,0,0,433.015,197.18Z",
    fill: "url(#linear-gradient-211)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1570",
    "data-name": "Path 1570",
    d: "M365.388,216.233c-1.251-29.5,29.541-15.378,29.541-15.378.616,3.934,2.294,12.985.237,14.688C379.468,228.528,365.388,216.233,365.388,216.233Z",
    fill: "url(#linear-gradient-212)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1571",
    "data-name": "Path 1571",
    d: "M405.489,265.651c-3.959.016-13.883,2.7-13.6,4.148.87,4.39,10.059,5.126,14.017,5.107s11.976-1.025,12.142-4.772C418.118,268.66,409.45,265.634,405.489,265.651Z",
    fill: "url(#linear-gradient-213)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1572",
    "data-name": "Path 1572",
    d: "M432.744,162.074c-.991-.271-2.092-.539-3.29-.8-8.734-1.9-22.489-8.33-35.008-8.33a81.6,81.6,0,0,0-20.162,2.916,19.677,19.677,0,0,0-6.057,2.486c-4.739,3.221-7.5,15.638-9.091,30.148-.514,4.712.882,31.467.621,34.919,1.186-3.9,3.051-9.322,6.272-13.053,2.334-18.681-1.494-32.369,6.4-38.042,5.426-3.9,20.218,2.625,30.749,3.068,21.228.892,25.646-5.2,27.854-2.65,8.845,10.234,3.624,22.24,15.249,46.309,0,0-.676-29.426-1.438-37.627C443.845,170.673,441.026,164.357,432.744,162.074Z",
    fill: "url(#linear-gradient-214)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1573",
    "data-name": "Path 1573",
    d: "M434.287,152.393s-14.121-12.641-37.508-11.05c-18.8,1.28-27.148,7.621-31.816,15.635-1.292,2.224-17.8,8.048-11.272,31.845.316,5.655-1.333,8.378.33,18.4,0,0,1.885.494,3.167,4.245.933,2.719,1.678,9.01,2.052,11.64.855-7.882,2.552-9.789,2.874-13.982.391-5.118.676-8,1.568-18.7.985-11.832,1.687-19.243,5.544-24.344,0,0,9.091-8.029,26.5.021,17.977,3.518,29.485.935,35.244-1.358,0,0,8.258,1.041,10.278,24.359.763,8.8.888,13.867,1.953,20.019.733,4.228,2.431,9.869,2.983,13.982,0,0-.106-15.409,4.265-16,.651-4.915.521-6.883-.922-20.9C454.112,175.505,447.953,156.277,434.287,152.393Z",
    fill: "url(#linear-gradient-215)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1574",
    "data-name": "Path 1574",
    d: "M440.869,217.788c-1.365-.766-2.377.344-5.211,1.277-2.781.915-10.375,2.351-6.8,4.291,3.944,2.148,9.458-.793,10.126-1.346S442.554,218.737,440.869,217.788Z",
    fill: "url(#linear-gradient-216)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1575",
    "data-name": "Path 1575",
    d: "M368.933,219.386c-2.878-.789-3.947-1.844-5.27-1.009-1.632,1.033,1.407,3.6,2.1,4.119s6.354,3.172,10.181.826C379.413,221.2,371.756,220.158,368.933,219.386Z",
    fill: "url(#linear-gradient-217)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1576",
    "data-name": "Path 1576",
    d: "M400.674,164.745c-12.984-3.285-19.789-7.386-27.248-5.014a16.236,16.236,0,0,0-11.249,12.807c-2.5,12.2.543,29.219.543,29.219s1.3-14.377,2.117-22.78c.856-8.855,3.923-10.67,8.589-11.871,5.753-1.478,15.319.59,22.9,2.132,28.27,5.753,34.944-5.453,34.944-5.453C419.924,167.559,407.684,166.52,400.674,164.745Z",
    fill: "url(#linear-gradient-218)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_545",
    "data-name": "Group 545"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_543",
    "data-name": "Group 543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1577",
    "data-name": "Path 1577",
    d: "M419.833,236.026c11.714,9.474,2.736,15.591,2.736,15.591,3.608-3.174,9.319-6.993,8.974-8.422C430.388,238.394,419.833,236.026,419.833,236.026Z",
    fill: "url(#linear-gradient-219)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1578",
    "data-name": "Path 1578",
    d: "M425.451,243.119l3.038-.924a4.527,4.527,0,0,1-.805,1.558,45.229,45.229,0,0,1-5.2,1.451Z",
    fill: "#e1b18c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1579",
    "data-name": "Path 1579",
    d: "M376.738,243.922c.212,1.473,4.375,5.1,7.106,7.927,0,0-7.292-7.842,2.849-14.9C386.693,236.944,376.024,238.97,376.738,243.922Z",
    fill: "url(#linear-gradient-220)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1580",
    "data-name": "Path 1580",
    d: "M382.262,243.424l-3.038-.923a4.527,4.527,0,0,0,.8,1.558,45.229,45.229,0,0,0,5.2,1.451Z",
    fill: "#e1b18c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1581",
    "data-name": "Path 1581",
    d: "M394.174,263.334a80.548,80.548,0,0,1,21.22.162C405.785,257.519,394.174,263.334,394.174,263.334Z",
    fill: "url(#linear-gradient-221)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1582",
    "data-name": "Path 1582",
    d: "M380.357,243.094c.258.268.445.634.779.782,6.081,2.693,6.165,5.264,8.773,6.671a29.173,29.173,0,0,0,27.276-.232c4.173-2.3,4.707-4.987,9.7-6.934a1.265,1.265,0,0,0,.8-.783C401.005,249.123,380.357,243.094,380.357,243.094Z",
    fill: "#96282d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1583",
    "data-name": "Path 1583",
    d: "M404.263,255.8c-3.6,0-7.15-.7-7.15,0s3.127,2.268,6.727,2.266S411,256.5,411,255.8,407.864,255.8,404.263,255.8Z",
    fill: "#fdd8b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1584",
    "data-name": "Path 1584",
    d: "M391.417,248.742c-1.125-.205-1.61,1.762-1.61,1.762,3.39,2.473,7.47,3.41,13.989,3.456,8.707.06,13.51-3.708,13.51-3.708s-1.225-1.894-2.657-1.607a60.017,60.017,0,0,1-11.277,1.417A68.379,68.379,0,0,1,391.417,248.742Z",
    fill: "url(#linear-gradient-222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1585",
    "data-name": "Path 1585",
    d: "M390.974,256.708c13.894,11.05,27.187-.756,27.187-.756C404.12,263.424,390.974,256.708,390.974,256.708Z",
    fill: "url(#linear-gradient-223)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1586",
    "data-name": "Path 1586",
    d: "M386.393,244.369a3.96,3.96,0,0,0,2.412,3.287c1.347.581,4.365,2.876,16.105,2.518s14.055-3.193,14.592-3.688a6.244,6.244,0,0,0,1.449-2.481S403.269,247.463,386.393,244.369Z",
    fill: "url(#linear-gradient-224)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1587",
    "data-name": "Path 1587",
    d: "M386.354,244.153a4.435,4.435,0,0,0,.459,1.652c.323.512,9.7,1.881,16.782,1.924s16.324-1.782,16.649-2.19a5.5,5.5,0,0,0,.79-1.762S413.065,246.455,386.354,244.153Z",
    fill: "#f3eceb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1588",
    "data-name": "Path 1588",
    d: "M378.909,242.372a15.547,15.547,0,0,0,1.448.722s20.648,6.029,47.327-.5l1.446-.725C414.643,244.292,378.909,242.372,378.909,242.372Z",
    fill: "url(#linear-gradient-225)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_544",
    "data-name": "Group 544"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1589",
    "data-name": "Path 1589",
    d: "M407.066,220.531c.428-8.463-2.534-9.676-4.724-9.6-2.133.075-3.312,3.007-2.878,9.461.429,6.428-.829,8.893-.541,11.9.134,1.372.768,2.268,4.243,2.295,3.816.028,5.142-.875,5.305-2.155C408.917,228.929,406.757,226.631,407.066,220.531Z",
    fill: "url(#linear-gradient-226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M392.894,235.62s9.585,6.966,11.673,6.557,9.78-6.557,9.78-6.557-8.695,1.069-10.694,1.069S392.894,235.62,392.894,235.62Z",
    fill: "url(#linear-gradient-227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1591",
    "data-name": "Path 1591",
    d: "M407.488,236.986c5.16-1.281,7.188-.521,7.188-.521C411.671,233.832,407.488,236.986,407.488,236.986Z",
    fill: "#e1b18c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1592",
    "data-name": "Path 1592",
    d: "M392.868,236.091a15.35,15.35,0,0,1,6.731.94S395.642,234.034,392.868,236.091Z",
    fill: "#e1b18c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1593",
    "data-name": "Path 1593",
    d: "M411.477,228.4c-.034,2.116.456,3.531-.188,4.738-1.435,2.686-5.15,3.751-7.636,3.548-1.882.228-6.293-.714-8.128-3.531-.749-1.148-.278-2.176-.615-4.427,0,0-5.107,6.165-2.042,7.36,0,0,.9-.673,3.365-.451s1.959,2.937,7.626,2.991c4.939.045,3.363-2.321,6.507-2.77s3.546.359,4.259.671C416.194,236.532,415.066,231.317,411.477,228.4Z",
    fill: "url(#linear-gradient-228)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1594",
    "data-name": "Path 1594",
    d: "M398.38,232.026c-.216,1.379,1.722,2.862,5.2,2.89,3.816.028,4.669-1.48,4.351-2.748C406.044,224.658,399.181,226.9,398.38,232.026Z",
    fill: "url(#linear-gradient-229)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_1595",
    "data-name": "Path 1595",
    d: "M431.271,163.785s-.88.951-1.844,1.972c8.874,3.781,9.671,12.242,12.5,32.544,0,0,2.286-12.968.149-20.2C440.277,172.019,436.854,165.748,431.271,163.785Z",
    fill: "url(#linear-gradient-230)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1596",
    "data-name": "Path 1596",
    d: "M407.2,145.7c4.748,0,21.555,5.105,27.09,6.689-27.749-21.655-59.707-7.451-62.373-3.384,8.364-2.168,25.988,8.439,35.717,10.017,18.242,2.957,24.383,1.018,24.383,1.018C429.244,155.691,423.814,148.077,407.2,145.7Z",
    fill: "url(#linear-gradient-231)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1597",
    "data-name": "Path 1597",
    d: "M412.081,215.046c-.457-.85.7-5.238.861-6.056.467-2.33,3.677-3.728,12.35-4.049,3.117-.116,6.991.851,8.153,1.735,2.279,1.737,3.99,5.244,3.957,6.479s-4.973,4.23-10.228,4.622C422.134,218.151,413.428,217.549,412.081,215.046Z",
    fill: "url(#linear-gradient-232)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1598",
    "data-name": "Path 1598",
    d: "M420.154,207.1c-5.209.37-6.995,7.691-6.995,7.691-.135.13.827.727,2.359,1.042,5.957,1.224,8.667,1.479,14.45.193a9.139,9.139,0,0,0,4.968-3.036C430.624,207.914,432.735,206.2,420.154,207.1Z",
    fill: "url(#linear-gradient-233)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1599",
    "data-name": "Path 1599",
    d: "M413.159,214.786a28.758,28.758,0,0,1,8.709-2.754c.61-.091,8.229.005,12.143,1.908a4.647,4.647,0,0,0,.925-.955s-2.1-5.739-6.145-5.349-13.206,1.041-13.206,1.041S413.832,213.1,413.159,214.786Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1600",
    "data-name": "Path 1600",
    d: "M423.852,208.048c-3.474-.206-6.715,1.608-6.552,5.242a6.973,6.973,0,0,0,1.028,3.079,35.164,35.164,0,0,0,5.481.681,20.117,20.117,0,0,0,5-.784,4.3,4.3,0,0,0,1.144-2.543C430.433,210.208,427.328,208.257,423.852,208.048Z",
    fill: "url(#linear-gradient-234)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1601",
    "data-name": "Path 1601",
    d: "M417.294,213.1a22.82,22.82,0,0,1,12.7-.39,3.97,3.97,0,0,0-4.353-3.861C421.247,208.943,417.031,209.024,417.294,213.1Z",
    fill: "url(#linear-gradient-235)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1602",
    "data-name": "Path 1602",
    d: "M424.125,209.342a3.763,3.763,0,1,0,3.748,3.876A3.809,3.809,0,0,0,424.125,209.342Z",
    fill: "url(#radial-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1603",
    "data-name": "Path 1603",
    d: "M426.5,212.309a1.646,1.646,0,0,0-1.414,1.821,1.6,1.6,0,0,0,1.771,1.427,1.638,1.638,0,0,0,1.417-1.821A1.59,1.59,0,0,0,426.5,212.309Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1604",
    "data-name": "Path 1604",
    d: "M423.006,210.941a1.288,1.288,0,1,0,1.4,1.129A1.266,1.266,0,0,0,423.006,210.941Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1605",
    "data-name": "Path 1605",
    d: "M413.159,214.786s.116-4.444,2.886-6.5c3.5-2.6,11.209-2.192,15.2-.813,3.277,1.131,3.687,5.511,3.687,5.511a6.375,6.375,0,0,0-4.4-2.577,33.533,33.533,0,0,0-13,.445C415.113,211.568,413.159,214.786,413.159,214.786Z",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1606",
    "data-name": "Path 1606",
    d: "M393.5,215.087c.922-1.008-.375-5-.636-6.445-.479-2.66-4.5-3.545-11.51-3.933-2.3-.126-7.313.464-8.872,1.851a15.653,15.653,0,0,0-3.717,6.363c-.034.77,3.492,4.334,10.167,4.849C383.925,218.158,391.583,217.181,393.5,215.087Z",
    fill: "url(#linear-gradient-236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1607",
    "data-name": "Path 1607",
    d: "M386.254,206.89c5.156.436,6.183,7.925,6.183,7.925a5.123,5.123,0,0,1-2.352,1,26.214,26.214,0,0,1-14.357.023c-2.282-.594-4.813-3.111-4.813-3.111C375.258,207.76,373.8,205.843,386.254,206.89Z",
    fill: "url(#linear-gradient-237)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1608",
    "data-name": "Path 1608",
    d: "M392.437,214.815s-3.866-3.21-11.354-3.254a18.43,18.43,0,0,0-8.761,2.388,7.642,7.642,0,0,1-1.407-1.22s2.134-5.64,6.133-5.2,13.011,1.866,13.011,1.866S391.792,213.131,392.437,214.815Z",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1609",
    "data-name": "Path 1609",
    d: "M382.332,208.256c3.391-.157,6.581,1.534,6.374,5.076a7.449,7.449,0,0,1-.968,3.044,36.638,36.638,0,0,1-5.434.539,21.018,21.018,0,0,1-4.909-.688,4.425,4.425,0,0,1-1.035-2.636C375.938,210.159,378.94,208.414,382.332,208.256Z",
    fill: "url(#linear-gradient-238)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1610",
    "data-name": "Path 1610",
    d: "M388.715,212.868s-7.016-1.62-12.327-.615a4.8,4.8,0,0,1,4.749-4.226C385.42,207.918,388.74,209.364,388.715,212.868Z",
    fill: "url(#linear-gradient-239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1611",
    "data-name": "Path 1611",
    d: "M382.344,209.279a3.671,3.671,0,1,1-3.71,3.731A3.708,3.708,0,0,1,382.344,209.279Z",
    fill: "url(#radial-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1612",
    "data-name": "Path 1612",
    d: "M383.415,214.739a1.575,1.575,0,0,1,.785-2.089,1.6,1.6,0,0,1,2.153.634,1.565,1.565,0,0,1-.781,2.088A1.6,1.6,0,0,1,383.415,214.739Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1613",
    "data-name": "Path 1613",
    d: "M380.221,212.607a1.227,1.227,0,0,1,.613-1.642,1.278,1.278,0,0,1,1.708.5,1.227,1.227,0,0,1-.614,1.642A1.272,1.272,0,0,1,380.221,212.607Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1614",
    "data-name": "Path 1614",
    d: "M392.437,214.815s-.542-4.738-3.258-6.812c-3.436-2.622-10.9-1.856-14.716-.435-2.35.878-3.548,5.161-3.548,5.161a7.61,7.61,0,0,1,4.158-2.377c7.224-1.168,10.678-.442,12.672.174C390.139,211.267,392.437,214.815,392.437,214.815Z",
    fill: "#3b3b3b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1615",
    "data-name": "Path 1615",
    d: "M373.14,197.365c8.713-1.465,15.695-1.207,21.1,1.161,2.047.9.418,3.954-2.019,3.894-4.582-.11-9.952-1.332-15.382-1.259-6.365.087-8.965,1.318-8.965,1.318S369.02,198.059,373.14,197.365Z",
    fill: "url(#linear-gradient-240)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M383.47,273.8s5.292,7.111,6.475,7.584,26.981.71,29.585-1.184a29.7,29.7,0,0,0,5.071-5.133s-5.071,3.714-7.2,4.188-22.249.945-25.562.236S383.47,273.8,383.47,273.8Z",
    fill: "url(#linear-gradient-241)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1617",
    "data-name": "Path 1617",
    d: "M359.29,225.827s2.034,16.157,9.475,27.292c1.954,2.924,12.773,17.981,14.064,19.864,0,0-8.461-8.644-10.117-10.065s-10.029-10.041-10.769-11.6C360.167,247.594,359.605,234.21,359.29,225.827Z",
    fill: "url(#linear-gradient-242)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1618",
    "data-name": "Path 1618",
    d: "M446.254,226.277s-.526,21.731-1.473,25.044-17.985,20.742-18.932,22.4c0,0,11.848-20.6,13.473-23.508C441.81,245.758,445.422,233.907,446.254,226.277Z",
    fill: "url(#linear-gradient-243)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1619",
    "data-name": "Path 1619",
    d: "M446.346,205.7c-.083-.466-2.662-.133-3.4-.112s-1.293-2.587-9.011-3.057a67.849,67.849,0,0,0-20.948,1.517c-1.167.284-4.556,2.048-4.879,1.856-.081-.048-9.781-.048-9.862,0-.323.192-3.712-1.572-4.879-1.856a67.849,67.849,0,0,0-20.948-1.517c-7.718.47-8.272,3.077-9.011,3.057s-3.319-.354-3.4.112a22.448,22.448,0,0,0,0,3.706c.046.564,2.651.375,2.651.375.255.712,1.629,12.859,5.572,15.054,6.589,3.667,20.8,2.111,21.743,1.785,5.218-1.8,8.963-17.011,9.5-17.3a22.346,22.346,0,0,1,3.725-.447,27.544,27.544,0,0,1,3.685.447c.537.286,4.282,15.492,9.5,17.3.942.326,15.154,1.882,21.742-1.785,3.944-2.2,5.318-14.342,5.573-15.054,0,0,2.6.189,2.65-.375A22.236,22.236,0,0,0,446.346,205.7Zm-50.241,9.185c-.57,2.228-3.352,9.476-6.687,10.473-4.544,1.36-11.42.766-14.8.272-3.971-.578-6.048-1.767-7.187-5.7-1.235-4.264-1.376-10.157-1.462-10.862s.355-2.889,2.022-3.29c10.877-2.618,21.028-.242,22.908-.033.845.094,4.039.882,4.848,2.208S397.256,210.391,396.105,214.887Zm44.282-5.815c-.086.7-.227,6.6-1.462,10.862-1.139,3.931-3.216,5.12-7.187,5.7-3.384.494-10.26,1.088-14.8-.272-3.335-1-6.117-8.245-6.688-10.473-1.15-4.5-.446-5.6.363-6.93s4-2.114,4.848-2.208c1.88-.209,12.031-2.585,22.908.033C440.032,206.183,440.473,208.367,440.387,209.072Z",
    fill: "url(#linear-gradient-244)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginDoctor);
export default __webpack_public_path__ + "static/media/login-doctor.c5b0826dbd79c880cabde857f612809d.svg";
export { ForwardRef as ReactComponent };